interface EmojiCategory {
    id: string;
    name: string;
    icon: string;
}

interface Emoji {
    unicode: string;
    name: string;
    decimal: string;
    category: string;
    shorthand?: string;
}

export const EmojiCategories: EmojiCategory[] = [
    {
        id: 'smileys_and_emotion',
        name: 'Smileys & Emotion',
        icon: 'icon-smile',
    },
    {
        id: 'people_and_body',
        name: 'People & Body',
        icon: 'icon-thumbs-up-solid',
    },
    {
        id: 'animals_and_nature',
        name: 'Animals & Nature',
        icon: 'icon-leaf',
    },
    {
        id: 'food_and_drink',
        name: 'Foods & Drinks',
        icon: 'icon-hamburger',
    },
    {
        id: 'travel_and_places',
        name: 'Travel & Places',
        icon: 'icon-globe',
    },
    {
        id: 'activities',
        name: 'Activities',
        icon: 'icon-football',
    },
    {
        id: 'objects',
        name: 'Objects',
        icon: 'icon-book',
    },
    {
        id: 'symbols',
        name: 'Symbols',
        icon: 'icon-exclamation-triangle',
    },
    {
        id: 'flags',
        name: 'Flags',
        icon: 'icon-flag',
    },
];

export const EmojisShorthand: any = {
    ')': {
        unicode: '1f642',
        name: 'slightly_smiling_face',
        decimal: '&#128578;',
        category: 'smileys_and_emotion',
    },
    ';)': {
        unicode: '1f609',
        name: 'winking_face',
        decimal: '&#128521;',
        category: 'smileys_and_emotion',
        shorthand: ';)',
    },
    '(': {
        unicode: '1f61e',
        name: 'disappointed_face',
        decimal: '&#128542;',
        category: 'smileys_and_emotion',
        shorthand: '(',
    },
};

export const Emojis: Emoji[] = [
    {
        unicode: '1f600',
        name: 'grinning_face',
        decimal: '&#128512;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f603',
        name: 'grinning_face_with_big_eyes',
        decimal: '&#128515;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f604',
        name: 'grinning_face_with_smiling_eyes',
        decimal: '&#128516;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f601',
        name: 'beaming_face_with_smiling_eyes',
        decimal: '&#128513;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f606',
        name: 'grinning_squinting_face',
        decimal: '&#128518;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f605',
        name: 'grinning_face_with_sweat',
        decimal: '&#128517;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f602',
        name: 'face_with_tears_of_joy',
        decimal: '&#128514;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f642',
        name: 'slightly_smiling_face',
        decimal: '&#128578;',
        category: 'smileys_and_emotion',
        shorthand: ')',
    },
    {
        unicode: '1f609',
        name: 'winking_face',
        decimal: '&#128521;',
        category: 'smileys_and_emotion',
        shorthand: ';)',
    },
    {
        unicode: '1f60a',
        name: 'smiling_face_with_smiling_eyes',
        decimal: '&#128522;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f60d',
        name: 'smiling_face_with_heart-eyes',
        decimal: '&#128525;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f618',
        name: 'face_blowing_a_kiss',
        decimal: '&#128536;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f61a',
        name: 'kissing_face_with_closed_eyes',
        decimal: '&#128538;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f60b',
        name: 'face_savoring_food',
        decimal: '&#128523;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f61c',
        name: 'winking_face_with_tongue',
        decimal: '&#128540;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f61d',
        name: 'squinting_face_with_tongue',
        decimal: '&#128541;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f60f',
        name: 'smirking_face',
        decimal: '&#128527;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f612',
        name: 'unamused_face',
        decimal: '&#128530;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f60c',
        name: 'relieved_face',
        decimal: '&#128524;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f614',
        name: 'pensive_face',
        decimal: '&#128532;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f62a',
        name: 'sleepy_face',
        decimal: '&#128554;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f637',
        name: 'face_with_medical_mask',
        decimal: '&#128567;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f635',
        name: 'dizzy_face',
        decimal: '&#128565;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f60e',
        name: 'smiling_face_with_sunglasses',
        decimal: '&#128526;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f615',
        name: 'confused_face',
        decimal: '&#128533;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f61f',
        name: 'worried_face',
        decimal: '&#128543;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f632',
        name: 'astonished_face',
        decimal: '&#128562;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f633',
        name: 'flushed_face',
        decimal: '&#128563;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f628',
        name: 'fearful_face',
        decimal: '&#128552;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f630',
        name: 'anxious_face_with_sweat',
        decimal: '&#128560;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f625',
        name: 'sad_but_relieved_face',
        decimal: '&#128549;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f622',
        name: 'crying_face',
        decimal: '&#128546;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f62d',
        name: 'loudly_crying_face',
        decimal: '&#128557;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f631',
        name: 'face_screaming_in_fear',
        decimal: '&#128561;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f616',
        name: 'confounded_face',
        decimal: '&#128534;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f623',
        name: 'persevering_face',
        decimal: '&#128547;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f61e',
        name: 'disappointed_face',
        decimal: '&#128542;',
        category: 'smileys_and_emotion',
        shorthand: '(',
    },
    {
        unicode: '1f613',
        name: 'downcast_face_with_sweat',
        decimal: '&#128531;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f629',
        name: 'weary_face',
        decimal: '&#128553;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f62b',
        name: 'tired_face',
        decimal: '&#128555;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f624',
        name: 'face_with_steam_from_nose',
        decimal: '&#128548;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f621',
        name: 'pouting_face',
        decimal: '&#128545;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f620',
        name: 'angry_face',
        decimal: '&#128544;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f47f',
        name: 'angry_face_with_horns',
        decimal: '&#128127;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f480',
        name: 'skull',
        decimal: '&#128128;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f4a9',
        name: 'pile_of_poo',
        decimal: '&#128169;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f479',
        name: 'ogre',
        decimal: '&#128121;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f47a',
        name: 'goblin',
        decimal: '&#128122;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f47b',
        name: 'ghost',
        decimal: '&#128123;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f47d',
        name: 'alien',
        decimal: '&#128125;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f47e',
        name: 'alien_monster',
        decimal: '&#128126;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f63a',
        name: 'grinning_cat',
        decimal: '&#128570;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f638',
        name: 'grinning_cat_with_smiling_eyes',
        decimal: '&#128568;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f639',
        name: 'cat_with_tears_of_joy',
        decimal: '&#128569;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f63b',
        name: 'smiling_cat_with_heart-eyes',
        decimal: '&#128571;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f63c',
        name: 'cat_with_wry_smile',
        decimal: '&#128572;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f63d',
        name: 'kissing_cat',
        decimal: '&#128573;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f640',
        name: 'weary_cat',
        decimal: '&#128576;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f63f',
        name: 'crying_cat',
        decimal: '&#128575;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f63e',
        name: 'pouting_cat',
        decimal: '&#128574;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f648',
        name: 'see-no-evil_monkey',
        decimal: '&#128584;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f649',
        name: 'hear-no-evil_monkey',
        decimal: '&#128585;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f64a',
        name: 'speak-no-evil_monkey',
        decimal: '&#128586;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f48b',
        name: 'kiss_mark',
        decimal: '&#128139;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f48c',
        name: 'love_letter',
        decimal: '&#128140;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f498',
        name: 'heart_with_arrow',
        decimal: '&#128152;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f49d',
        name: 'heart_with_ribbon',
        decimal: '&#128157;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f496',
        name: 'sparkling_heart',
        decimal: '&#128150;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f497',
        name: 'growing_heart',
        decimal: '&#128151;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f493',
        name: 'beating_heart',
        decimal: '&#128147;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f49e',
        name: 'revolving_hearts',
        decimal: '&#128158;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f495',
        name: 'two_hearts',
        decimal: '&#128149;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f49f',
        name: 'heart_decoration',
        decimal: '&#128159;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f494',
        name: 'broken_heart',
        decimal: '&#128148;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '2764',
        name: 'red_heart',
        decimal: '&#10084;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f49b',
        name: 'yellow_heart',
        decimal: '&#128155;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f49a',
        name: 'green_heart',
        decimal: '&#128154;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f499',
        name: 'blue_heart',
        decimal: '&#128153;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f49c',
        name: 'purple_heart',
        decimal: '&#128156;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f4af',
        name: 'hundred_points',
        decimal: '&#128175;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f4a2',
        name: 'anger_symbol',
        decimal: '&#128162;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f4a5',
        name: 'collision',
        decimal: '&#128165;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f4ab',
        name: 'dizzy',
        decimal: '&#128171;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f4a6',
        name: 'sweat_droplets',
        decimal: '&#128166;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f4a8',
        name: 'dashing_away',
        decimal: '&#128168;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f4a3',
        name: 'bomb',
        decimal: '&#128163;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f4ac',
        name: 'speech_balloon',
        decimal: '&#128172;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f4a4',
        name: 'zzz',
        decimal: '&#128164;',
        category: 'smileys_and_emotion',
    },
    {
        unicode: '1f44b',
        name: 'waving_hand',
        decimal: '&#128075;',
        category: 'people_and_body',
    },
    {
        unicode: '270b',
        name: 'raised_hand',
        decimal: '&#9995;',
        category: 'people_and_body',
    },
    {
        unicode: '1f44c',
        name: 'OK_hand',
        decimal: '&#128076;',
        category: 'people_and_body',
    },
    {
        unicode: '270c',
        name: 'victory_hand',
        decimal: '&#9996;',
        category: 'people_and_body',
    },
    {
        unicode: '1f448',
        name: 'backhand_index_pointing_left',
        decimal: '&#128072;',
        category: 'people_and_body',
    },
    {
        unicode: '1f449',
        name: 'backhand_index_pointing_right',
        decimal: '&#128073;',
        category: 'people_and_body',
    },
    {
        unicode: '1f446',
        name: 'backhand_index_pointing_up',
        decimal: '&#128070;',
        category: 'people_and_body',
    },
    {
        unicode: '1f447',
        name: 'backhand_index_pointing_down',
        decimal: '&#128071;',
        category: 'people_and_body',
    },
    {
        unicode: '261d',
        name: 'index_pointing_up',
        decimal: '&#9757;',
        category: 'people_and_body',
    },
    {
        unicode: '1f44d',
        name: 'thumbs_up',
        decimal: '&#128077;',
        category: 'people_and_body',
    },
    {
        unicode: '1f44e',
        name: 'thumbs_down',
        decimal: '&#128078;',
        category: 'people_and_body',
    },
    {
        unicode: '270a',
        name: 'raised_fist',
        decimal: '&#9994;',
        category: 'people_and_body',
    },
    {
        unicode: '1f44a',
        name: 'oncoming_fist',
        decimal: '&#128074;',
        category: 'people_and_body',
    },
    {
        unicode: '1f44f',
        name: 'clapping_hands',
        decimal: '&#128079;',
        category: 'people_and_body',
    },
    {
        unicode: '1f64c',
        name: 'raising_hands',
        decimal: '&#128588;',
        category: 'people_and_body',
    },
    {
        unicode: '1f450',
        name: 'open_hands',
        decimal: '&#128080;',
        category: 'people_and_body',
    },
    {
        unicode: '1f64f',
        name: 'folded_hands',
        decimal: '&#128591;',
        category: 'people_and_body',
    },
    {
        unicode: '1f485',
        name: 'nail_polish',
        decimal: '&#128133;',
        category: 'people_and_body',
    },
    {
        unicode: '1f4aa',
        name: 'flexed_biceps',
        decimal: '&#128170;',
        category: 'people_and_body',
    },
    {
        unicode: '1f442',
        name: 'ear',
        decimal: '&#128066;',
        category: 'people_and_body',
    },
    {
        unicode: '1f443',
        name: 'nose',
        decimal: '&#128067;',
        category: 'people_and_body',
    },
    {
        unicode: '1f440',
        name: 'eyes',
        decimal: '&#128064;',
        category: 'people_and_body',
    },
    {
        unicode: '1f445',
        name: 'tongue',
        decimal: '&#128069;',
        category: 'people_and_body',
    },
    {
        unicode: '1f444',
        name: 'mouth',
        decimal: '&#128068;',
        category: 'people_and_body',
    },
    {
        unicode: '1f476',
        name: 'baby',
        decimal: '&#128118;',
        category: 'people_and_body',
    },
    {
        unicode: '1f466',
        name: 'boy',
        decimal: '&#128102;',
        category: 'people_and_body',
    },
    {
        unicode: '1f467',
        name: 'girl',
        decimal: '&#128103;',
        category: 'people_and_body',
    },
    {
        unicode: '1f471',
        name: 'person_blond_hair',
        decimal: '&#128113;',
        category: 'people_and_body',
    },
    {
        unicode: '1f468',
        name: 'man',
        decimal: '&#128104;',
        category: 'people_and_body',
    },
    {
        unicode: '1f469',
        name: 'woman',
        decimal: '&#128105;',
        category: 'people_and_body',
    },
    {
        unicode: '1f474',
        name: 'old_man',
        decimal: '&#128116;',
        category: 'people_and_body',
    },
    {
        unicode: '1f475',
        name: 'old_woman',
        decimal: '&#128117;',
        category: 'people_and_body',
    },
    {
        unicode: '1f64d',
        name: 'person_frowning',
        decimal: '&#128589;',
        category: 'people_and_body',
    },
    {
        unicode: '1f64e',
        name: 'person_pouting',
        decimal: '&#128590;',
        category: 'people_and_body',
    },
    {
        unicode: '1f645',
        name: 'person_gesturing_NO',
        decimal: '&#128581;',
        category: 'people_and_body',
    },
    {
        unicode: '1f646',
        name: 'person_gesturing_OK',
        decimal: '&#128582;',
        category: 'people_and_body',
    },
    {
        unicode: '1f481',
        name: 'person_tipping_hand',
        decimal: '&#128129;',
        category: 'people_and_body',
    },
    {
        unicode: '1f64b',
        name: 'person_raising_hand',
        decimal: '&#128587;',
        category: 'people_and_body',
    },
    {
        unicode: '1f647',
        name: 'person_bowing',
        decimal: '&#128583;',
        category: 'people_and_body',
    },
    {
        unicode: '1f46e',
        name: 'police_officer',
        decimal: '&#128110;',
        category: 'people_and_body',
    },
    {
        unicode: '1f482',
        name: 'guard',
        decimal: '&#128130;',
        category: 'people_and_body',
    },
    {
        unicode: '1f477',
        name: 'construction_worker',
        decimal: '&#128119;',
        category: 'people_and_body',
    },
    {
        unicode: '1f478',
        name: 'princess',
        decimal: '&#128120;',
        category: 'people_and_body',
    },
    {
        unicode: '1f473',
        name: 'person_wearing_turban',
        decimal: '&#128115;',
        category: 'people_and_body',
    },
    {
        unicode: '1f472',
        name: 'man_with_Chinese_cap',
        decimal: '&#128114;',
        category: 'people_and_body',
    },
    {
        unicode: '1f470',
        name: 'bride_with_veil',
        decimal: '&#128112;',
        category: 'people_and_body',
    },
    {
        unicode: '1f47c',
        name: 'baby_angel',
        decimal: '&#128124;',
        category: 'people_and_body',
    },
    {
        unicode: '1f385',
        name: 'Santa_Claus',
        decimal: '&#127877;',
        category: 'people_and_body',
    },
    {
        unicode: '1f486',
        name: 'person_getting_massage',
        decimal: '&#128134;',
        category: 'people_and_body',
    },
    {
        unicode: '1f487',
        name: 'person_getting_haircut',
        decimal: '&#128135;',
        category: 'people_and_body',
    },
    {
        unicode: '1f6b6',
        name: 'person_walking',
        decimal: '&#128694;',
        category: 'people_and_body',
    },
    {
        unicode: '1f3c3',
        name: 'person_running',
        decimal: '&#127939;',
        category: 'people_and_body',
    },
    {
        unicode: '1f483',
        name: 'woman_dancing',
        decimal: '&#128131;',
        category: 'people_and_body',
    },
    {
        unicode: '1f46f',
        name: 'people_with_bunny_ears',
        decimal: '&#128111;',
        category: 'people_and_body',
    },
    {
        unicode: '1f3c2',
        name: 'snowboarder',
        decimal: '&#127938;',
        category: 'people_and_body',
    },
    {
        unicode: '1f3c4',
        name: 'person_surfing',
        decimal: '&#127940;',
        category: 'people_and_body',
    },
    {
        unicode: '1f3ca',
        name: 'person_swimming',
        decimal: '&#127946;',
        category: 'people_and_body',
    },
    {
        unicode: '1f6c0',
        name: 'person_taking_bath',
        decimal: '&#128704;',
        category: 'people_and_body',
    },
    {
        unicode: '1f46b',
        name: 'woman_and_man_holding_hands',
        decimal: '&#128107;',
        category: 'people_and_body',
    },
    {
        unicode: '1f48f',
        name: 'kiss',
        decimal: '&#128143;',
        category: 'people_and_body',
    },
    {
        unicode: '1f491',
        name: 'couple_with_heart',
        decimal: '&#128145;',
        category: 'people_and_body',
    },
    {
        unicode: '1f46a',
        name: 'family',
        decimal: '&#128106;',
        category: 'people_and_body',
    },
    {
        unicode: '1f464',
        name: 'bust_in_silhouette',
        decimal: '&#128100;',
        category: 'people_and_body',
    },
    {
        unicode: '1f463',
        name: 'footprints',
        decimal: '&#128099;',
        category: 'people_and_body',
    },
    {
        unicode: '1f435',
        name: 'monkey_face',
        decimal: '&#128053;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f412',
        name: 'monkey',
        decimal: '&#128018;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f436',
        name: 'dog_face',
        decimal: '&#128054;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f429',
        name: 'poodle',
        decimal: '&#128041;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f43a',
        name: 'wolf',
        decimal: '&#128058;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f431',
        name: 'cat_face',
        decimal: '&#128049;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f42f',
        name: 'tiger_face',
        decimal: '&#128047;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f434',
        name: 'horse_face',
        decimal: '&#128052;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f40e',
        name: 'horse',
        decimal: '&#128014;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f42e',
        name: 'cow_face',
        decimal: '&#128046;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f437',
        name: 'pig_face',
        decimal: '&#128055;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f417',
        name: 'boar',
        decimal: '&#128023;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f43d',
        name: 'pig_nose',
        decimal: '&#128061;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f411',
        name: 'ewe',
        decimal: '&#128017;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f42b',
        name: 'two-hump_camel',
        decimal: '&#128043;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f418',
        name: 'elephant',
        decimal: '&#128024;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f42d',
        name: 'mouse_face',
        decimal: '&#128045;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f439',
        name: 'hamster',
        decimal: '&#128057;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f430',
        name: 'rabbit_face',
        decimal: '&#128048;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f43b',
        name: 'bear',
        decimal: '&#128059;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f428',
        name: 'koala',
        decimal: '&#128040;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f43c',
        name: 'panda',
        decimal: '&#128060;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f43e',
        name: 'paw_prints',
        decimal: '&#128062;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f414',
        name: 'chicken',
        decimal: '&#128020;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f423',
        name: 'hatching_chick',
        decimal: '&#128035;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f424',
        name: 'baby_chick',
        decimal: '&#128036;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f425',
        name: 'front-facing_baby_chick',
        decimal: '&#128037;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f426',
        name: 'bird',
        decimal: '&#128038;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f427',
        name: 'penguin',
        decimal: '&#128039;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f438',
        name: 'frog',
        decimal: '&#128056;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f422',
        name: 'turtle',
        decimal: '&#128034;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f40d',
        name: 'snake',
        decimal: '&#128013;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f432',
        name: 'dragon_face',
        decimal: '&#128050;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f433',
        name: 'spouting_whale',
        decimal: '&#128051;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f42c',
        name: 'dolphin',
        decimal: '&#128044;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f41f',
        name: 'fish',
        decimal: '&#128031;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f420',
        name: 'tropical_fish',
        decimal: '&#128032;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f421',
        name: 'blowfish',
        decimal: '&#128033;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f419',
        name: 'octopus',
        decimal: '&#128025;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f41a',
        name: 'spiral_shell',
        decimal: '&#128026;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f40c',
        name: 'snail',
        decimal: '&#128012;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f41b',
        name: 'bug',
        decimal: '&#128027;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f41c',
        name: 'ant',
        decimal: '&#128028;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f41d',
        name: 'honeybee',
        decimal: '&#128029;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f41e',
        name: 'lady_beetle',
        decimal: '&#128030;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f490',
        name: 'bouquet',
        decimal: '&#128144;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f338',
        name: 'cherry_blossom',
        decimal: '&#127800;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f4ae',
        name: 'white_flower',
        decimal: '&#128174;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f339',
        name: 'rose',
        decimal: '&#127801;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f33a',
        name: 'hibiscus',
        decimal: '&#127802;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f33b',
        name: 'sunflower',
        decimal: '&#127803;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f33c',
        name: 'blossom',
        decimal: '&#127804;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f337',
        name: 'tulip',
        decimal: '&#127799;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f331',
        name: 'seedling',
        decimal: '&#127793;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f334',
        name: 'palm_tree',
        decimal: '&#127796;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f335',
        name: 'cactus',
        decimal: '&#127797;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f33e',
        name: 'sheaf_of_rice',
        decimal: '&#127806;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f33f',
        name: 'herb',
        decimal: '&#127807;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f340',
        name: 'four_leaf_clover',
        decimal: '&#127808;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f341',
        name: 'maple_leaf',
        decimal: '&#127809;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f342',
        name: 'fallen_leaf',
        decimal: '&#127810;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f343',
        name: 'leaf_fluttering_in_wind',
        decimal: '&#127811;',
        category: 'animals_and_nature',
    },
    {
        unicode: '1f347',
        name: 'grapes',
        decimal: '&#127815;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f348',
        name: 'melon',
        decimal: '&#127816;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f349',
        name: 'watermelon',
        decimal: '&#127817;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f34a',
        name: 'tangerine',
        decimal: '&#127818;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f34c',
        name: 'banana',
        decimal: '&#127820;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f34d',
        name: 'pineapple',
        decimal: '&#127821;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f34e',
        name: 'red_apple',
        decimal: '&#127822;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f34f',
        name: 'green_apple',
        decimal: '&#127823;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f351',
        name: 'peach',
        decimal: '&#127825;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f352',
        name: 'cherries',
        decimal: '&#127826;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f353',
        name: 'strawberry',
        decimal: '&#127827;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f345',
        name: 'tomato',
        decimal: '&#127813;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f346',
        name: 'eggplant',
        decimal: '&#127814;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f33d',
        name: 'ear_of_corn',
        decimal: '&#127805;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f344',
        name: 'mushroom',
        decimal: '&#127812;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f330',
        name: 'chestnut',
        decimal: '&#127792;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f35e',
        name: 'bread',
        decimal: '&#127838;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f356',
        name: 'meat_on_bone',
        decimal: '&#127830;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f357',
        name: 'poultry_leg',
        decimal: '&#127831;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f354',
        name: 'hamburger',
        decimal: '&#127828;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f35f',
        name: 'french_fries',
        decimal: '&#127839;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f355',
        name: 'pizza',
        decimal: '&#127829;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f373',
        name: 'cooking',
        decimal: '&#127859;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f372',
        name: 'pot_of_food',
        decimal: '&#127858;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f371',
        name: 'bento_box',
        decimal: '&#127857;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f358',
        name: 'rice_cracker',
        decimal: '&#127832;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f359',
        name: 'rice_ball',
        decimal: '&#127833;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f35a',
        name: 'cooked_rice',
        decimal: '&#127834;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f35b',
        name: 'curry_rice',
        decimal: '&#127835;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f35c',
        name: 'steaming_bowl',
        decimal: '&#127836;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f35d',
        name: 'spaghetti',
        decimal: '&#127837;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f360',
        name: 'roasted_sweet_potato',
        decimal: '&#127840;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f362',
        name: 'oden',
        decimal: '&#127842;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f363',
        name: 'sushi',
        decimal: '&#127843;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f364',
        name: 'fried_shrimp',
        decimal: '&#127844;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f365',
        name: 'fish_cake_with_swirl',
        decimal: '&#127845;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f361',
        name: 'dango',
        decimal: '&#127841;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f366',
        name: 'soft_ice_cream',
        decimal: '&#127846;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f367',
        name: 'shaved_ice',
        decimal: '&#127847;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f368',
        name: 'ice_cream',
        decimal: '&#127848;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f369',
        name: 'doughnut',
        decimal: '&#127849;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f36a',
        name: 'cookie',
        decimal: '&#127850;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f382',
        name: 'birthday_cake',
        decimal: '&#127874;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f370',
        name: 'shortcake',
        decimal: '&#127856;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f36b',
        name: 'chocolate_bar',
        decimal: '&#127851;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f36c',
        name: 'candy',
        decimal: '&#127852;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f36d',
        name: 'lollipop',
        decimal: '&#127853;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f36e',
        name: 'custard',
        decimal: '&#127854;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f36f',
        name: 'honey_pot',
        decimal: '&#127855;',
        category: 'food_and_drink',
    },
    {
        unicode: '2615',
        name: 'hot_beverage',
        decimal: '&#9749;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f375',
        name: 'teacup_without_handle',
        decimal: '&#127861;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f376',
        name: 'sake',
        decimal: '&#127862;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f377',
        name: 'wine_glass',
        decimal: '&#127863;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f378',
        name: 'cocktail_glass',
        decimal: '&#127864;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f379',
        name: 'tropical_drink',
        decimal: '&#127865;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f37a',
        name: 'beer_mug',
        decimal: '&#127866;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f37b',
        name: 'clinking_beer_mugs',
        decimal: '&#127867;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f374',
        name: 'fork_and_knife',
        decimal: '&#127860;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f52a',
        name: 'kitchen_knife',
        decimal: '&#128298;',
        category: 'food_and_drink',
    },
    {
        unicode: '1F32E',
        name: 'taco',
        decimal: '&#127790;',
        category: 'food_and_drink',
    },
    {
        unicode: '1F32F',
        name: 'burrito',
        decimal: '&#127791;',
        category: 'food_and_drink',
    },
    {
        unicode: '1F951',
        name: 'avocado',
        decimal: '&#129361;',
        category: 'food_and_drink',
    },
    {
        unicode: '1F336',
        name: 'hot_pepper',
        decimal: '&#127798;',
        category: 'food_and_drink',
    },
    {
        unicode: '1F952',
        name: 'cucumber',
        decimal: '&#129362;',
        category: 'food_and_drink',
    },
    {
        unicode: '1F96C',
        name: 'leafy_green',
        decimal: '&#129388;',
        category: 'food_and_drink',
    },
    {
        unicode: '1F9C4',
        name: 'garlic',
        decimal: '&#129476;',
        category: 'food_and_drink',
    },
    {
        unicode: '1F9C5',
        name: 'onion',
        decimal: '&#129477;',
        category: 'food_and_drink',
    },
    {
        unicode: '1f30f',
        name: 'globe_showing_Asia-Australia',
        decimal: '&#127759;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f5fe',
        name: 'map_of_Japan',
        decimal: '&#128510;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f30b',
        name: 'volcano',
        decimal: '&#127755;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f5fb',
        name: 'mount_fuji',
        decimal: '&#128507;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3e0',
        name: 'house',
        decimal: '&#127968;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3e1',
        name: 'house_with_garden',
        decimal: '&#127969;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3e2',
        name: 'office_building',
        decimal: '&#127970;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3e3',
        name: 'Japanese_post_office',
        decimal: '&#127971;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3e5',
        name: 'hospital',
        decimal: '&#127973;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3e6',
        name: 'bank',
        decimal: '&#127974;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3e8',
        name: 'hotel',
        decimal: '&#127976;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3e9',
        name: 'love_hotel',
        decimal: '&#127977;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3ea',
        name: 'convenience_store',
        decimal: '&#127978;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3eb',
        name: 'school',
        decimal: '&#127979;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3ec',
        name: 'department_store',
        decimal: '&#127980;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3ed',
        name: 'factory',
        decimal: '&#127981;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3ef',
        name: 'Japanese_castle',
        decimal: '&#127983;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3f0',
        name: 'castle',
        decimal: '&#127984;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f492',
        name: 'wedding',
        decimal: '&#128146;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f5fc',
        name: 'Tokyo_tower',
        decimal: '&#128508;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f5fd',
        name: 'Statue_of_Liberty',
        decimal: '&#128509;',
        category: 'travel_and_places',
    },
    {
        unicode: '26ea',
        name: 'church',
        decimal: '&#9962;',
        category: 'travel_and_places',
    },
    {
        unicode: '26f2',
        name: 'fountain',
        decimal: '&#9970;',
        category: 'travel_and_places',
    },
    {
        unicode: '26fa',
        name: 'tent',
        decimal: '&#9978;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f301',
        name: 'foggy',
        decimal: '&#127745;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f303',
        name: 'night_with_stars',
        decimal: '&#127747;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f304',
        name: 'sunrise_over_mountains',
        decimal: '&#127748;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f305',
        name: 'sunrise',
        decimal: '&#127749;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f306',
        name: 'cityscape_at_dusk',
        decimal: '&#127750;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f307',
        name: 'sunset',
        decimal: '&#127751;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f309',
        name: 'bridge_at_night',
        decimal: '&#127753;',
        category: 'travel_and_places',
    },
    {
        unicode: '2668',
        name: 'hot_springs',
        decimal: '&#9832;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3a0',
        name: 'carousel_horse',
        decimal: '&#127904;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3a1',
        name: 'ferris_wheel',
        decimal: '&#127905;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3a2',
        name: 'roller_coaster',
        decimal: '&#127906;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f488',
        name: 'barber_pole',
        decimal: '&#128136;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f3aa',
        name: 'circus_tent',
        decimal: '&#127914;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f683',
        name: 'railway_car',
        decimal: '&#128643;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f684',
        name: 'high-speed_train',
        decimal: '&#128644;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f685',
        name: 'bullet_train',
        decimal: '&#128645;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f687',
        name: 'metro',
        decimal: '&#128647;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f689',
        name: 'station',
        decimal: '&#128649;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f68c',
        name: 'bus',
        decimal: '&#128652;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f691',
        name: 'ambulance',
        decimal: '&#128657;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f692',
        name: 'fire_engine',
        decimal: '&#128658;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f693',
        name: 'police_car',
        decimal: '&#128659;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f695',
        name: 'taxi',
        decimal: '&#128661;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f697',
        name: 'automobile',
        decimal: '&#128663;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f699',
        name: 'sport_utility_vehicle',
        decimal: '&#128665;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f69a',
        name: 'delivery_truck',
        decimal: '&#128666;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f6b2',
        name: 'bicycle',
        decimal: '&#128690;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f68f',
        name: 'bus_stop',
        decimal: '&#128655;',
        category: 'travel_and_places',
    },
    {
        unicode: '26fd',
        name: 'fuel_pump',
        decimal: '&#9981;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f6a8',
        name: 'police_car_light',
        decimal: '&#128680;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f6a5',
        name: 'horizontal_traffic_light',
        decimal: '&#128677;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f6a7',
        name: 'construction',
        decimal: '&#128679;',
        category: 'travel_and_places',
    },
    {
        unicode: '2693',
        name: 'anchor',
        decimal: '&#9875;',
        category: 'travel_and_places',
    },
    {
        unicode: '26f5',
        name: 'sailboat',
        decimal: '&#9973;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f6a4',
        name: 'speedboat',
        decimal: '&#128676;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f6a2',
        name: 'ship',
        decimal: '&#128674;',
        category: 'travel_and_places',
    },
    {
        unicode: '2708',
        name: 'airplane',
        decimal: '&#9992;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f4ba',
        name: 'seat',
        decimal: '&#128186;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f680',
        name: 'rocket',
        decimal: '&#128640;',
        category: 'travel_and_places',
    },
    {
        unicode: '231b',
        name: 'hourglass_done',
        decimal: '&#8987;',
        category: 'travel_and_places',
    },
    {
        unicode: '23f3',
        name: 'hourglass_not_done',
        decimal: '&#9203;',
        category: 'travel_and_places',
    },
    {
        unicode: '231a',
        name: 'watch',
        decimal: '&#8986;',
        category: 'travel_and_places',
    },
    {
        unicode: '23f0',
        name: 'alarm_clock',
        decimal: '&#9200;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f55b',
        name: 'twelve_o’clock',
        decimal: '&#128347;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f550',
        name: 'one_o’clock',
        decimal: '&#128336;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f551',
        name: 'two_o’clock',
        decimal: '&#128337;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f552',
        name: 'three_o’clock',
        decimal: '&#128338;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f553',
        name: 'four_o’clock',
        decimal: '&#128339;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f554',
        name: 'five_o’clock',
        decimal: '&#128340;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f555',
        name: 'six_o’clock',
        decimal: '&#128341;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f556',
        name: 'seven_o’clock',
        decimal: '&#128342;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f557',
        name: 'eight_o’clock',
        decimal: '&#128343;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f558',
        name: 'nine_o’clock',
        decimal: '&#128344;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f559',
        name: 'ten_o’clock',
        decimal: '&#128345;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f55a',
        name: 'eleven_o’clock',
        decimal: '&#128346;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f311',
        name: 'new_moon',
        decimal: '&#127761;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f313',
        name: 'first_quarter_moon',
        decimal: '&#127763;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f314',
        name: 'waxing_gibbous_moon',
        decimal: '&#127764;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f315',
        name: 'full_moon',
        decimal: '&#127765;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f319',
        name: 'crescent_moon',
        decimal: '&#127769;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f31b',
        name: 'first_quarter_moon_face',
        decimal: '&#127771;',
        category: 'travel_and_places',
    },
    {
        unicode: '2600',
        name: 'sun',
        decimal: '&#9728;',
        category: 'travel_and_places',
    },
    {
        unicode: '2b50',
        name: 'star',
        decimal: '&#11088;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f31f',
        name: 'glowing_star',
        decimal: '&#127775;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f320',
        name: 'shooting_star',
        decimal: '&#127776;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f30c',
        name: 'milky_way',
        decimal: '&#127756;',
        category: 'travel_and_places',
    },
    {
        unicode: '2601',
        name: 'cloud',
        decimal: '&#9729;',
        category: 'travel_and_places',
    },
    {
        unicode: '26c5',
        name: 'sun_behind_cloud',
        decimal: '&#9925;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f300',
        name: 'cyclone',
        decimal: '&#127744;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f308',
        name: 'rainbow',
        decimal: '&#127752;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f302',
        name: 'closed_umbrella',
        decimal: '&#127746;',
        category: 'travel_and_places',
    },
    {
        unicode: '2614',
        name: 'umbrella_with_rain_drops',
        decimal: '&#9748;',
        category: 'travel_and_places',
    },
    {
        unicode: '26a1',
        name: 'high_voltage',
        decimal: '&#9889;',
        category: 'travel_and_places',
    },
    {
        unicode: '2744',
        name: 'snowflake',
        decimal: '&#10052;',
        category: 'travel_and_places',
    },
    {
        unicode: '26c4',
        name: 'snowman_without_snow',
        decimal: '&#9924;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f525',
        name: 'fire',
        decimal: '&#128293;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f4a7',
        name: 'droplet',
        decimal: '&#128167;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f30a',
        name: 'water_wave',
        decimal: '&#127754;',
        category: 'travel_and_places',
    },
    {
        unicode: '1f383',
        name: 'jack-o-lantern',
        decimal: '&#127875;',
        category: 'activities',
    },
    {
        unicode: '1f384',
        name: 'Christmas_tree',
        decimal: '&#127876;',
        category: 'activities',
    },
    {
        unicode: '1f386',
        name: 'fireworks',
        decimal: '&#127878;',
        category: 'activities',
    },
    {
        unicode: '1f387',
        name: 'sparkler',
        decimal: '&#127879;',
        category: 'activities',
    },
    {
        unicode: '2728',
        name: 'sparkles',
        decimal: '&#10024;',
        category: 'activities',
    },
    {
        unicode: '1f388',
        name: 'balloon',
        decimal: '&#127880;',
        category: 'activities',
    },
    {
        unicode: '1f389',
        name: 'party_popper',
        decimal: '&#127881;',
        category: 'activities',
    },
    {
        unicode: '1f38a',
        name: 'confetti_ball',
        decimal: '&#127882;',
        category: 'activities',
    },
    {
        unicode: '1f38b',
        name: 'tanabata_tree',
        decimal: '&#127883;',
        category: 'activities',
    },
    {
        unicode: '1f38d',
        name: 'pine_decoration',
        decimal: '&#127885;',
        category: 'activities',
    },
    {
        unicode: '1f38e',
        name: 'Japanese_dolls',
        decimal: '&#127886;',
        category: 'activities',
    },
    {
        unicode: '1f38f',
        name: 'carp_streamer',
        decimal: '&#127887;',
        category: 'activities',
    },
    {
        unicode: '1f390',
        name: 'wind_chime',
        decimal: '&#127888;',
        category: 'activities',
    },
    {
        unicode: '1f391',
        name: 'moon_viewing_ceremony',
        decimal: '&#127889;',
        category: 'activities',
    },
    {
        unicode: '1f380',
        name: 'ribbon',
        decimal: '&#127872;',
        category: 'activities',
    },
    {
        unicode: '1f381',
        name: 'wrapped_gift',
        decimal: '&#127873;',
        category: 'activities',
    },
    {
        unicode: '1f3ab',
        name: 'ticket',
        decimal: '&#127915;',
        category: 'activities',
    },
    {
        unicode: '1f3c6',
        name: 'trophy',
        decimal: '&#127942;',
        category: 'activities',
    },
    {
        unicode: '26bd',
        name: 'soccer_ball',
        decimal: '&#9917;',
        category: 'activities',
    },
    {
        unicode: '26be',
        name: 'baseball',
        decimal: '&#9918;',
        category: 'activities',
    },
    {
        unicode: '1f3c0',
        name: 'basketball',
        decimal: '&#127936;',
        category: 'activities',
    },
    {
        unicode: '1f3c8',
        name: 'american_football',
        decimal: '&#127944;',
        category: 'activities',
    },
    {
        unicode: '1f3be',
        name: 'tennis',
        decimal: '&#127934;',
        category: 'activities',
    },
    {
        unicode: '1f3b3',
        name: 'bowling',
        decimal: '&#127923;',
        category: 'activities',
    },
    {
        unicode: '26f3',
        name: 'flag_in_hole',
        decimal: '&#9971;',
        category: 'activities',
    },
    {
        unicode: '1f3a3',
        name: 'fishing_pole',
        decimal: '&#127907;',
        category: 'activities',
    },
    {
        unicode: '1f3bd',
        name: 'running_shirt',
        decimal: '&#127933;',
        category: 'activities',
    },
    {
        unicode: '1f3bf',
        name: 'skis',
        decimal: '&#127935;',
        category: 'activities',
    },
    {
        unicode: '1f3af',
        name: 'direct_hit',
        decimal: '&#127919;',
        category: 'activities',
    },
    {
        unicode: '1f3b1',
        name: 'pool_8_ball',
        decimal: '&#127921;',
        category: 'activities',
    },
    {
        unicode: '1f52e',
        name: 'crystal_ball',
        decimal: '&#128302;',
        category: 'activities',
    },
    {
        unicode: '1f3ae',
        name: 'video_game',
        decimal: '&#127918;',
        category: 'activities',
    },
    {
        unicode: '1f3b0',
        name: 'slot_machine',
        decimal: '&#127920;',
        category: 'activities',
    },
    {
        unicode: '1f3b2',
        name: 'game_die',
        decimal: '&#127922;',
        category: 'activities',
    },
    {
        unicode: '2660',
        name: 'spade_suit',
        decimal: '&#9824;',
        category: 'activities',
    },
    {
        unicode: '2665',
        name: 'heart_suit',
        decimal: '&#9829;',
        category: 'activities',
    },
    {
        unicode: '2666',
        name: 'diamond_suit',
        decimal: '&#9830;',
        category: 'activities',
    },
    {
        unicode: '2663',
        name: 'club_suit',
        decimal: '&#9827;',
        category: 'activities',
    },
    {
        unicode: '1f0cf',
        name: 'joker',
        decimal: '&#127183;',
        category: 'activities',
    },
    {
        unicode: '1f004',
        name: 'mahjong_red_dragon',
        decimal: '&#126980;',
        category: 'activities',
    },
    {
        unicode: '1f3b4',
        name: 'flower_playing_cards',
        decimal: '&#127924;',
        category: 'activities',
    },
    {
        unicode: '1f3ad',
        name: 'performing_arts',
        decimal: '&#127917;',
        category: 'activities',
    },
    {
        unicode: '1f3a8',
        name: 'artist_palette',
        decimal: '&#127912;',
        category: 'activities',
    },
    {
        unicode: '1f453',
        name: 'glasses',
        decimal: '&#128083;',
        category: 'objects',
    },
    {
        unicode: '1f454',
        name: 'necktie',
        decimal: '&#128084;',
        category: 'objects',
    },
    {
        unicode: '1f455',
        name: 't-shirt',
        decimal: '&#128085;',
        category: 'objects',
    },
    {
        unicode: '1f456',
        name: 'jeans',
        decimal: '&#128086;',
        category: 'objects',
    },
    {
        unicode: '1f457',
        name: 'dress',
        decimal: '&#128087;',
        category: 'objects',
    },
    {
        unicode: '1f458',
        name: 'kimono',
        decimal: '&#128088;',
        category: 'objects',
    },
    {
        unicode: '1f459',
        name: 'bikini',
        decimal: '&#128089;',
        category: 'objects',
    },
    {
        unicode: '1f45a',
        name: 'woman’s_clothes',
        decimal: '&#128090;',
        category: 'objects',
    },
    {
        unicode: '1f45b',
        name: 'purse',
        decimal: '&#128091;',
        category: 'objects',
    },
    {
        unicode: '1f45c',
        name: 'handbag',
        decimal: '&#128092;',
        category: 'objects',
    },
    {
        unicode: '1f45d',
        name: 'clutch_bag',
        decimal: '&#128093;',
        category: 'objects',
    },
    {
        unicode: '1f392',
        name: 'backpack',
        decimal: '&#127890;',
        category: 'objects',
    },
    {
        unicode: '1f45e',
        name: 'man’s_shoe',
        decimal: '&#128094;',
        category: 'objects',
    },
    {
        unicode: '1f45f',
        name: 'running_shoe',
        decimal: '&#128095;',
        category: 'objects',
    },
    {
        unicode: '1f460',
        name: 'high-heeled_shoe',
        decimal: '&#128096;',
        category: 'objects',
    },
    {
        unicode: '1f461',
        name: 'woman’s_sandal',
        decimal: '&#128097;',
        category: 'objects',
    },
    {
        unicode: '1f462',
        name: 'woman’s_boot',
        decimal: '&#128098;',
        category: 'objects',
    },
    {
        unicode: '1f451',
        name: 'crown',
        decimal: '&#128081;',
        category: 'objects',
    },
    {
        unicode: '1f452',
        name: 'woman’s_hat',
        decimal: '&#128082;',
        category: 'objects',
    },
    {
        unicode: '1f3a9',
        name: 'top_hat',
        decimal: '&#127913;',
        category: 'objects',
    },
    {
        unicode: '1f393',
        name: 'graduation_cap',
        decimal: '&#127891;',
        category: 'objects',
    },
    {
        unicode: '1f484',
        name: 'lipstick',
        decimal: '&#128132;',
        category: 'objects',
    },
    {
        unicode: '1f48d',
        name: 'ring',
        decimal: '&#128141;',
        category: 'objects',
    },
    {
        unicode: '1f48e',
        name: 'gem_stone',
        decimal: '&#128142;',
        category: 'objects',
    },
    {
        unicode: '1f50a',
        name: 'speaker_high_volume',
        decimal: '&#128266;',
        category: 'objects',
    },
    {
        unicode: '1f4e2',
        name: 'loudspeaker',
        decimal: '&#128226;',
        category: 'objects',
    },
    {
        unicode: '1f4e3',
        name: 'megaphone',
        decimal: '&#128227;',
        category: 'objects',
    },
    {
        unicode: '1f514',
        name: 'bell',
        decimal: '&#128276;',
        category: 'objects',
    },
    {
        unicode: '1f3bc',
        name: 'musical_score',
        decimal: '&#127932;',
        category: 'objects',
    },
    {
        unicode: '1f3b5',
        name: 'musical_note',
        decimal: '&#127925;',
        category: 'objects',
    },
    {
        unicode: '1f3b6',
        name: 'musical_notes',
        decimal: '&#127926;',
        category: 'objects',
    },
    {
        unicode: '1f3a4',
        name: 'microphone',
        decimal: '&#127908;',
        category: 'objects',
    },
    {
        unicode: '1f3a7',
        name: 'headphone',
        decimal: '&#127911;',
        category: 'objects',
    },
    {
        unicode: '1f4fb',
        name: 'radio',
        decimal: '&#128251;',
        category: 'objects',
    },
    {
        unicode: '1f3b7',
        name: 'saxophone',
        decimal: '&#127927;',
        category: 'objects',
    },
    {
        unicode: '1f3b8',
        name: 'guitar',
        decimal: '&#127928;',
        category: 'objects',
    },
    {
        unicode: '1f3b9',
        name: 'musical_keyboard',
        decimal: '&#127929;',
        category: 'objects',
    },
    {
        unicode: '1f3ba',
        name: 'trumpet',
        decimal: '&#127930;',
        category: 'objects',
    },
    {
        unicode: '1f3bb',
        name: 'violin',
        decimal: '&#127931;',
        category: 'objects',
    },
    {
        unicode: '1f4f1',
        name: 'mobile_phone',
        decimal: '&#128241;',
        category: 'objects',
    },
    {
        unicode: '1f4f2',
        name: 'mobile_phone_with_arrow',
        decimal: '&#128242;',
        category: 'objects',
    },
    {
        unicode: '260e',
        name: 'telephone',
        decimal: '&#9742;',
        category: 'objects',
    },
    {
        unicode: '1f4de',
        name: 'telephone_receiver',
        decimal: '&#128222;',
        category: 'objects',
    },
    {
        unicode: '1f4df',
        name: 'pager',
        decimal: '&#128223;',
        category: 'objects',
    },
    {
        unicode: '1f4e0',
        name: 'fax_machine',
        decimal: '&#128224;',
        category: 'objects',
    },
    {
        unicode: '1f50b',
        name: 'battery',
        decimal: '&#128267;',
        category: 'objects',
    },
    {
        unicode: '1f50c',
        name: 'electric_plug',
        decimal: '&#128268;',
        category: 'objects',
    },
    {
        unicode: '1f4bb',
        name: 'laptop_computer',
        decimal: '&#128187;',
        category: 'objects',
    },
    {
        unicode: '1f4bd',
        name: 'computer_disk',
        decimal: '&#128189;',
        category: 'objects',
    },
    {
        unicode: '1f4be',
        name: 'floppy_disk',
        decimal: '&#128190;',
        category: 'objects',
    },
    {
        unicode: '1f4bf',
        name: 'optical_disk',
        decimal: '&#128191;',
        category: 'objects',
    },
    {
        unicode: '1f4c0',
        name: 'dvd',
        decimal: '&#128192;',
        category: 'objects',
    },
    {
        unicode: '1f3a5',
        name: 'movie_camera',
        decimal: '&#127909;',
        category: 'objects',
    },
    {
        unicode: '1f3ac',
        name: 'clapper_board',
        decimal: '&#127916;',
        category: 'objects',
    },
    {
        unicode: '1f4fa',
        name: 'television',
        decimal: '&#128250;',
        category: 'objects',
    },
    {
        unicode: '1f4f7',
        name: 'camera',
        decimal: '&#128247;',
        category: 'objects',
    },
    {
        unicode: '1f4f9',
        name: 'video_camera',
        decimal: '&#128249;',
        category: 'objects',
    },
    {
        unicode: '1f4fc',
        name: 'videocassette',
        decimal: '&#128252;',
        category: 'objects',
    },
    {
        unicode: '1f50d',
        name: 'magnifying_glass_tilted_left',
        decimal: '&#128269;',
        category: 'objects',
    },
    {
        unicode: '1f50e',
        name: 'magnifying_glass_tilted_right',
        decimal: '&#128270;',
        category: 'objects',
    },
    {
        unicode: '1f4a1',
        name: 'light_bulb',
        decimal: '&#128161;',
        category: 'objects',
    },
    {
        unicode: '1f526',
        name: 'flashlight',
        decimal: '&#128294;',
        category: 'objects',
    },
    {
        unicode: '1f3ee',
        name: 'red_paper_lantern',
        decimal: '&#127982;',
        category: 'objects',
    },
    {
        unicode: '1f4d4',
        name: 'notebook_with_decorative_cover',
        decimal: '&#128212;',
        category: 'objects',
    },
    {
        unicode: '1f4d5',
        name: 'closed_book',
        decimal: '&#128213;',
        category: 'objects',
    },
    {
        unicode: '1f4d6',
        name: 'open_book',
        decimal: '&#128214;',
        category: 'objects',
    },
    {
        unicode: '1f4d7',
        name: 'green_book',
        decimal: '&#128215;',
        category: 'objects',
    },
    {
        unicode: '1f4d8',
        name: 'blue_book',
        decimal: '&#128216;',
        category: 'objects',
    },
    {
        unicode: '1f4d9',
        name: 'orange_book',
        decimal: '&#128217;',
        category: 'objects',
    },
    {
        unicode: '1f4da',
        name: 'books',
        decimal: '&#128218;',
        category: 'objects',
    },
    {
        unicode: '1f4d3',
        name: 'notebook',
        decimal: '&#128211;',
        category: 'objects',
    },
    {
        unicode: '1f4d2',
        name: 'ledger',
        decimal: '&#128210;',
        category: 'objects',
    },
    {
        unicode: '1f4c3',
        name: 'page_with_curl',
        decimal: '&#128195;',
        category: 'objects',
    },
    {
        unicode: '1f4dc',
        name: 'scroll',
        decimal: '&#128220;',
        category: 'objects',
    },
    {
        unicode: '1f4c4',
        name: 'page_facing_up',
        decimal: '&#128196;',
        category: 'objects',
    },
    {
        unicode: '1f4f0',
        name: 'newspaper',
        decimal: '&#128240;',
        category: 'objects',
    },
    {
        unicode: '1f4d1',
        name: 'bookmark_tabs',
        decimal: '&#128209;',
        category: 'objects',
    },
    {
        unicode: '1f516',
        name: 'bookmark',
        decimal: '&#128278;',
        category: 'objects',
    },
    {
        unicode: '1f4b0',
        name: 'money_bag',
        decimal: '&#128176;',
        category: 'objects',
    },
    {
        unicode: '1f4b4',
        name: 'yen_banknote',
        decimal: '&#128180;',
        category: 'objects',
    },
    {
        unicode: '1f4b5',
        name: 'dollar_banknote',
        decimal: '&#128181;',
        category: 'objects',
    },
    {
        unicode: '1f4b8',
        name: 'money_with_wings',
        decimal: '&#128184;',
        category: 'objects',
    },
    {
        unicode: '1f4b3',
        name: 'credit_card',
        decimal: '&#128179;',
        category: 'objects',
    },
    {
        unicode: '1f4b9',
        name: 'chart_increasing_with_yen',
        decimal: '&#128185;',
        category: 'objects',
    },
    {
        unicode: '1f4b1',
        name: 'currency_exchange',
        decimal: '&#128177;',
        category: 'objects',
    },
    {
        unicode: '1f4b2',
        name: 'heavy_dollar_sign',
        decimal: '&#128178;',
        category: 'objects',
    },
    {
        unicode: '2709',
        name: 'envelope',
        decimal: '&#9993;',
        category: 'objects',
    },
    {
        unicode: '1f4e7',
        name: 'e-mail',
        decimal: '&#128231;',
        category: 'objects',
    },
    {
        unicode: '1f4e8',
        name: 'incoming_envelope',
        decimal: '&#128232;',
        category: 'objects',
    },
    {
        unicode: '1f4e9',
        name: 'envelope_with_arrow',
        decimal: '&#128233;',
        category: 'objects',
    },
    {
        unicode: '1f4e4',
        name: 'outbox_tray',
        decimal: '&#128228;',
        category: 'objects',
    },
    {
        unicode: '1f4e5',
        name: 'inbox_tray',
        decimal: '&#128229;',
        category: 'objects',
    },
    {
        unicode: '1f4e6',
        name: 'package',
        decimal: '&#128230;',
        category: 'objects',
    },
    {
        unicode: '1f4eb',
        name: 'closed_mailbox_with_raised_flag',
        decimal: '&#128235;',
        category: 'objects',
    },
    {
        unicode: '1f4ea',
        name: 'closed_mailbox_with_lowered_flag',
        decimal: '&#128234;',
        category: 'objects',
    },
    {
        unicode: '1f4ee',
        name: 'postbox',
        decimal: '&#128238;',
        category: 'objects',
    },
    {
        unicode: '270f',
        name: 'pencil',
        decimal: '&#9999;',
        category: 'objects',
    },
    {
        unicode: '2712',
        name: 'black_nib',
        decimal: '&#10002;',
        category: 'objects',
    },
    {
        unicode: '1f4dd',
        name: 'memo',
        decimal: '&#128221;',
        category: 'objects',
    },
    {
        unicode: '1f4bc',
        name: 'briefcase',
        decimal: '&#128188;',
        category: 'objects',
    },
    {
        unicode: '1f4c1',
        name: 'file_folder',
        decimal: '&#128193;',
        category: 'objects',
    },
    {
        unicode: '1f4c2',
        name: 'open_file_folder',
        decimal: '&#128194;',
        category: 'objects',
    },
    {
        unicode: '1f4c5',
        name: 'calendar',
        decimal: '&#128197;',
        category: 'objects',
    },
    {
        unicode: '1f4c6',
        name: 'tear-off_calendar',
        decimal: '&#128198;',
        category: 'objects',
    },
    {
        unicode: '1f4c7',
        name: 'card_index',
        decimal: '&#128199;',
        category: 'objects',
    },
    {
        unicode: '1f4c8',
        name: 'chart_increasing',
        decimal: '&#128200;',
        category: 'objects',
    },
    {
        unicode: '1f4c9',
        name: 'chart_decreasing',
        decimal: '&#128201;',
        category: 'objects',
    },
    {
        unicode: '1f4ca',
        name: 'bar_chart',
        decimal: '&#128202;',
        category: 'objects',
    },
    {
        unicode: '1f4cb',
        name: 'clipboard',
        decimal: '&#128203;',
        category: 'objects',
    },
    {
        unicode: '1f4cc',
        name: 'pushpin',
        decimal: '&#128204;',
        category: 'objects',
    },
    {
        unicode: '1f4cd',
        name: 'round_pushpin',
        decimal: '&#128205;',
        category: 'objects',
    },
    {
        unicode: '1f4ce',
        name: 'paperclip',
        decimal: '&#128206;',
        category: 'objects',
    },
    {
        unicode: '1f4cf',
        name: 'straight_ruler',
        decimal: '&#128207;',
        category: 'objects',
    },
    {
        unicode: '1f4d0',
        name: 'triangular_ruler',
        decimal: '&#128208;',
        category: 'objects',
    },
    {
        unicode: '2702',
        name: 'scissors',
        decimal: '&#9986;',
        category: 'objects',
    },
    {
        unicode: '1f512',
        name: 'locked',
        decimal: '&#128274;',
        category: 'objects',
    },
    {
        unicode: '1f513',
        name: 'unlocked',
        decimal: '&#128275;',
        category: 'objects',
    },
    {
        unicode: '1f50f',
        name: 'locked_with_pen',
        decimal: '&#128271;',
        category: 'objects',
    },
    {
        unicode: '1f510',
        name: 'locked_with_key',
        decimal: '&#128272;',
        category: 'objects',
    },
    {
        unicode: '1f511',
        name: 'key',
        decimal: '&#128273;',
        category: 'objects',
    },
    {
        unicode: '1f528',
        name: 'hammer',
        decimal: '&#128296;',
        category: 'objects',
    },
    {
        unicode: '1f52b',
        name: 'pistol',
        decimal: '&#128299;',
        category: 'objects',
    },
    {
        unicode: '1f527',
        name: 'wrench',
        decimal: '&#128295;',
        category: 'objects',
    },
    {
        unicode: '1f529',
        name: 'nut_and_bolt',
        decimal: '&#128297;',
        category: 'objects',
    },
    {
        unicode: '1f517',
        name: 'link',
        decimal: '&#128279;',
        category: 'objects',
    },
    {
        unicode: '1f4e1',
        name: 'satellite_antenna',
        decimal: '&#128225;',
        category: 'objects',
    },
    {
        unicode: '1f489',
        name: 'syringe',
        decimal: '&#128137;',
        category: 'objects',
    },
    {
        unicode: '1f48a',
        name: 'pill',
        decimal: '&#128138;',
        category: 'objects',
    },
    {
        unicode: '1f6aa',
        name: 'door',
        decimal: '&#128682;',
        category: 'objects',
    },
    {
        unicode: '1f6bd',
        name: 'toilet',
        decimal: '&#128701;',
        category: 'objects',
    },
    {
        unicode: '1f6ac',
        name: 'cigarette',
        decimal: '&#128684;',
        category: 'objects',
    },
    {
        unicode: '1f5ff',
        name: 'moai',
        decimal: '&#128511;',
        category: 'objects',
    },
    {
        unicode: '1F9B7',
        name: 'tooth',
        decimal: '&#129463;',
        category: 'objects',
    },
    {
        unicode: '1FAA5',
        name: 'toothbrush',
        decimal: '&#129701;',
        category: 'objects',
    },
    {
        unicode: '1f3e7',
        name: 'ATM_sign',
        decimal: '&#127975;',
        category: 'symbols',
    },
    {
        unicode: '267f',
        name: 'wheelchair_symbol',
        decimal: '&#9855;',
        category: 'symbols',
    },
    {
        unicode: '1f6b9',
        name: 'men’s_room',
        decimal: '&#128697;',
        category: 'symbols',
    },
    {
        unicode: '1f6ba',
        name: 'women’s_room',
        decimal: '&#128698;',
        category: 'symbols',
    },
    {
        unicode: '1f6bb',
        name: 'restroom',
        decimal: '&#128699;',
        category: 'symbols',
    },
    {
        unicode: '1f6bc',
        name: 'baby_symbol',
        decimal: '&#128700;',
        category: 'symbols',
    },
    {
        unicode: '1f6be',
        name: 'water_closet',
        decimal: '&#128702;',
        category: 'symbols',
    },
    {
        unicode: '26a0',
        name: 'warning',
        decimal: '&#9888;',
        category: 'symbols',
    },
    {
        unicode: '26d4',
        name: 'no_entry',
        decimal: '&#9940;',
        category: 'symbols',
    },
    {
        unicode: '1f6ab',
        name: 'prohibited',
        decimal: '&#128683;',
        category: 'symbols',
    },
    {
        unicode: '1f6ad',
        name: 'no_smoking',
        decimal: '&#128685;',
        category: 'symbols',
    },
    {
        unicode: '1f51e',
        name: 'no_one_under_eighteen',
        decimal: '&#128286;',
        category: 'symbols',
    },
    {
        unicode: '2b06',
        name: 'up_arrow',
        decimal: '&#11014;',
        category: 'symbols',
    },
    {
        unicode: '2197',
        name: 'up-right_arrow',
        decimal: '&#8599;',
        category: 'symbols',
    },
    {
        unicode: '27a1',
        name: 'right_arrow',
        decimal: '&#10145;',
        category: 'symbols',
    },
    {
        unicode: '2198',
        name: 'down-right_arrow',
        decimal: '&#8600;',
        category: 'symbols',
    },
    {
        unicode: '2b07',
        name: 'down_arrow',
        decimal: '&#11015;',
        category: 'symbols',
    },
    {
        unicode: '2199',
        name: 'down-left_arrow',
        decimal: '&#8601;',
        category: 'symbols',
    },
    {
        unicode: '2b05',
        name: 'left_arrow',
        decimal: '&#11013;',
        category: 'symbols',
    },
    {
        unicode: '2196',
        name: 'up-left_arrow',
        decimal: '&#8598;',
        category: 'symbols',
    },
    {
        unicode: '2195',
        name: 'up-down_arrow',
        decimal: '&#8597;',
        category: 'symbols',
    },
    {
        unicode: '2194',
        name: 'left-right_arrow',
        decimal: '&#8596;',
        category: 'symbols',
    },
    {
        unicode: '21a9',
        name: 'right_arrow_curving_left',
        decimal: '&#8617;',
        category: 'symbols',
    },
    {
        unicode: '21aa',
        name: 'left_arrow_curving_right',
        decimal: '&#8618;',
        category: 'symbols',
    },
    {
        unicode: '2934',
        name: 'right_arrow_curving_up',
        decimal: '&#10548;',
        category: 'symbols',
    },
    {
        unicode: '2935',
        name: 'right_arrow_curving_down',
        decimal: '&#10549;',
        category: 'symbols',
    },
    {
        unicode: '1f503',
        name: 'clockwise_vertical_arrows',
        decimal: '&#128259;',
        category: 'symbols',
    },
    {
        unicode: '1f519',
        name: 'BACK_arrow',
        decimal: '&#128281;',
        category: 'symbols',
    },
    {
        unicode: '1f51a',
        name: 'END_arrow',
        decimal: '&#128282;',
        category: 'symbols',
    },
    {
        unicode: '1f51b',
        name: 'ON!_arrow',
        decimal: '&#128283;',
        category: 'symbols',
    },
    {
        unicode: '1f51c',
        name: 'SOON_arrow',
        decimal: '&#128284;',
        category: 'symbols',
    },
    {
        unicode: '1f51d',
        name: 'TOP_arrow',
        decimal: '&#128285;',
        category: 'symbols',
    },
    {
        unicode: '1f52f',
        name: 'dotted_six-pointed_star',
        decimal: '&#128303;',
        category: 'symbols',
    },
    {
        unicode: '2648',
        name: 'Aries',
        decimal: '&#9800;',
        category: 'symbols',
    },
    {
        unicode: '2649',
        name: 'Taurus',
        decimal: '&#9801;',
        category: 'symbols',
    },
    {
        unicode: '264a',
        name: 'Gemini',
        decimal: '&#9802;',
        category: 'symbols',
    },
    {
        unicode: '264b',
        name: 'Cancer',
        decimal: '&#9803;',
        category: 'symbols',
    },
    {
        unicode: '264c',
        name: 'Leo',
        decimal: '&#9804;',
        category: 'symbols',
    },
    {
        unicode: '264d',
        name: 'Virgo',
        decimal: '&#9805;',
        category: 'symbols',
    },
    {
        unicode: '264e',
        name: 'Libra',
        decimal: '&#9806;',
        category: 'symbols',
    },
    {
        unicode: '264f',
        name: 'Scorpio',
        decimal: '&#9807;',
        category: 'symbols',
    },
    {
        unicode: '2650',
        name: 'Sagittarius',
        decimal: '&#9808;',
        category: 'symbols',
    },
    {
        unicode: '2651',
        name: 'Capricorn',
        decimal: '&#9809;',
        category: 'symbols',
    },
    {
        unicode: '2652',
        name: 'Aquarius',
        decimal: '&#9810;',
        category: 'symbols',
    },
    {
        unicode: '2653',
        name: 'Pisces',
        decimal: '&#9811;',
        category: 'symbols',
    },
    {
        unicode: '26ce',
        name: 'Ophiuchus',
        decimal: '&#9934;',
        category: 'symbols',
    },
    {
        unicode: '25b6',
        name: 'play_button',
        decimal: '&#9654;',
        category: 'symbols',
    },
    {
        unicode: '23e9',
        name: 'fast-forward_button',
        decimal: '&#9193;',
        category: 'symbols',
    },
    {
        unicode: '25c0',
        name: 'reverse_button',
        decimal: '&#9664;',
        category: 'symbols',
    },
    {
        unicode: '23ea',
        name: 'fast_reverse_button',
        decimal: '&#9194;',
        category: 'symbols',
    },
    {
        unicode: '1f53c',
        name: 'upwards_button',
        decimal: '&#128316;',
        category: 'symbols',
    },
    {
        unicode: '23eb',
        name: 'fast_up_button',
        decimal: '&#9195;',
        category: 'symbols',
    },
    {
        unicode: '1f53d',
        name: 'downwards_button',
        decimal: '&#128317;',
        category: 'symbols',
    },
    {
        unicode: '23ec',
        name: 'fast_down_button',
        decimal: '&#9196;',
        category: 'symbols',
    },
    {
        unicode: '1f3a6',
        name: 'cinema',
        decimal: '&#127910;',
        category: 'symbols',
    },
    {
        unicode: '1f4f6',
        name: 'antenna_bars',
        decimal: '&#128246;',
        category: 'symbols',
    },
    {
        unicode: '1f4f3',
        name: 'vibration_mode',
        decimal: '&#128243;',
        category: 'symbols',
    },
    {
        unicode: '1f4f4',
        name: 'mobile_phone_off',
        decimal: '&#128244;',
        category: 'symbols',
    },
    {
        unicode: '267b',
        name: 'recycling_symbol',
        decimal: '&#9851;',
        category: 'symbols',
    },
    {
        unicode: '1f531',
        name: 'trident_emblem',
        decimal: '&#128305;',
        category: 'symbols',
    },
    {
        unicode: '1f4db',
        name: 'name_badge',
        decimal: '&#128219;',
        category: 'symbols',
    },
    {
        unicode: '1f530',
        name: 'Japanese_symbol_for_beginner',
        decimal: '&#128304;',
        category: 'symbols',
    },
    {
        unicode: '2b55',
        name: 'hollow_red_circle',
        decimal: '&#11093;',
        category: 'symbols',
    },
    {
        unicode: '2705',
        name: 'check_mark_button',
        decimal: '&#9989;',
        category: 'symbols',
    },
    {
        unicode: '2611',
        name: 'check_box_with_check',
        decimal: '&#9745;',
        category: 'symbols',
    },
    {
        unicode: '2714',
        name: 'check_mark',
        decimal: '&#10004;',
        category: 'symbols',
    },
    {
        unicode: '2716',
        name: 'multiplication_sign',
        decimal: '&#10006;',
        category: 'symbols',
    },
    {
        unicode: '274c',
        name: 'cross_mark',
        decimal: '&#10060;',
        category: 'symbols',
    },
    {
        unicode: '274e',
        name: 'cross_mark_button',
        decimal: '&#10062;',
        category: 'symbols',
    },
    {
        unicode: '2795',
        name: 'plus_sign',
        decimal: '&#10133;',
        category: 'symbols',
    },
    {
        unicode: '2796',
        name: 'minus_sign',
        decimal: '&#10134;',
        category: 'symbols',
    },
    {
        unicode: '2797',
        name: 'division_sign',
        decimal: '&#10135;',
        category: 'symbols',
    },
    {
        unicode: '27b0',
        name: 'curly_loop',
        decimal: '&#10160;',
        category: 'symbols',
    },
    {
        unicode: '27bf',
        name: 'double_curly_loop',
        decimal: '&#10175;',
        category: 'symbols',
    },
    {
        unicode: '303d',
        name: 'part_alternation_mark',
        decimal: '&#12349;',
        category: 'symbols',
    },
    {
        unicode: '2733',
        name: 'eight-spoked_asterisk',
        decimal: '&#10035;',
        category: 'symbols',
    },
    {
        unicode: '2734',
        name: 'eight-pointed_star',
        decimal: '&#10036;',
        category: 'symbols',
    },
    {
        unicode: '2747',
        name: 'sparkle',
        decimal: '&#10055;',
        category: 'symbols',
    },
    {
        unicode: '203c',
        name: 'double_exclamation_mark',
        decimal: '&#8252;',
        category: 'symbols',
    },
    {
        unicode: '2049',
        name: 'exclamation_question_mark',
        decimal: '&#8265;',
        category: 'symbols',
    },
    {
        unicode: '2753',
        name: 'question_mark',
        decimal: '&#10067;',
        category: 'symbols',
    },
    {
        unicode: '2754',
        name: 'white_question_mark',
        decimal: '&#10068;',
        category: 'symbols',
    },
    {
        unicode: '2755',
        name: 'white_exclamation_mark',
        decimal: '&#10069;',
        category: 'symbols',
    },
    {
        unicode: '2757',
        name: 'exclamation_mark',
        decimal: '&#10071;',
        category: 'symbols',
    },
    {
        unicode: '3030',
        name: 'wavy_dash',
        decimal: '&#12336;',
        category: 'symbols',
    },
    {
        unicode: '00a9',
        name: 'copyright',
        decimal: '&#169;',
        category: 'symbols',
    },
    {
        unicode: '00ae',
        name: 'registered',
        decimal: '&#174;',
        category: 'symbols',
    },
    {
        unicode: '2122',
        name: 'trade_mark',
        decimal: '&#8482;',
        category: 'symbols',
    },
    {
        unicode: '0023_fe0f_20e3',
        name: 'keycap_#',
        decimal: '&#35;',
        category: 'symbols',
    },
    {
        unicode: '0030_fe0f_20e3',
        name: 'keycap_0',
        decimal: '&#48;',
        category: 'symbols',
    },
    {
        unicode: '0031_fe0f_20e3',
        name: 'keycap_1',
        decimal: '&#49;',
        category: 'symbols',
    },
    {
        unicode: '0032_fe0f_20e3',
        name: 'keycap_2',
        decimal: '&#50;',
        category: 'symbols',
    },
    {
        unicode: '0033_fe0f_20e3',
        name: 'keycap_3',
        decimal: '&#51;',
        category: 'symbols',
    },
    {
        unicode: '0034_fe0f_20e3',
        name: 'keycap_4',
        decimal: '&#52;',
        category: 'symbols',
    },
    {
        unicode: '0035_fe0f_20e3',
        name: 'keycap_5',
        decimal: '&#53;',
        category: 'symbols',
    },
    {
        unicode: '0036_fe0f_20e3',
        name: 'keycap_6',
        decimal: '&#54;',
        category: 'symbols',
    },
    {
        unicode: '0037_fe0f_20e3',
        name: 'keycap_7',
        decimal: '&#55;',
        category: 'symbols',
    },
    {
        unicode: '0038_fe0f_20e3',
        name: 'keycap_8',
        decimal: '&#56;',
        category: 'symbols',
    },
    {
        unicode: '0039_fe0f_20e3',
        name: 'keycap_9',
        decimal: '&#57;',
        category: 'symbols',
    },
    {
        unicode: '1f51f',
        name: 'keycap_10',
        decimal: '&#128287;',
        category: 'symbols',
    },
    {
        unicode: '1f520',
        name: 'input_latin_uppercase',
        decimal: '&#128288;',
        category: 'symbols',
    },
    {
        unicode: '1f521',
        name: 'input_latin_lowercase',
        decimal: '&#128289;',
        category: 'symbols',
    },
    {
        unicode: '1f522',
        name: 'input_numbers',
        decimal: '&#128290;',
        category: 'symbols',
    },
    {
        unicode: '1f523',
        name: 'input_symbols',
        decimal: '&#128291;',
        category: 'symbols',
    },
    {
        unicode: '1f524',
        name: 'input_latin_letters',
        decimal: '&#128292;',
        category: 'symbols',
    },
    {
        unicode: '1f170',
        name: 'A_button_(blood_type)',
        decimal: '&#127344;',
        category: 'symbols',
    },
    {
        unicode: '1f18e',
        name: 'AB_button_(blood_type)',
        decimal: '&#127374;',
        category: 'symbols',
    },
    {
        unicode: '1f171',
        name: 'B_button_(blood_type)',
        decimal: '&#127345;',
        category: 'symbols',
    },
    {
        unicode: '1f191',
        name: 'CL_button',
        decimal: '&#127377;',
        category: 'symbols',
    },
    {
        unicode: '1f192',
        name: 'COOL_button',
        decimal: '&#127378;',
        category: 'symbols',
    },
    {
        unicode: '1f193',
        name: 'FREE_button',
        decimal: '&#127379;',
        category: 'symbols',
    },
    {
        unicode: '2139',
        name: 'information',
        decimal: '&#8505;',
        category: 'symbols',
    },
    {
        unicode: '1f194',
        name: 'ID_button',
        decimal: '&#127380;',
        category: 'symbols',
    },
    {
        unicode: '24c2',
        name: 'circled_M',
        decimal: '&#9410;',
        category: 'symbols',
    },
    {
        unicode: '1f195',
        name: 'NEW_button',
        decimal: '&#127381;',
        category: 'symbols',
    },
    {
        unicode: '1f196',
        name: 'NG_button',
        decimal: '&#127382;',
        category: 'symbols',
    },
    {
        unicode: '1f17e',
        name: 'O_button_(blood_type)',
        decimal: '&#127358;',
        category: 'symbols',
    },
    {
        unicode: '1f197',
        name: 'OK_button',
        decimal: '&#127383;',
        category: 'symbols',
    },
    {
        unicode: '1f17f',
        name: 'P_button',
        decimal: '&#127359;',
        category: 'symbols',
    },
    {
        unicode: '1f198',
        name: 'SOS_button',
        decimal: '&#127384;',
        category: 'symbols',
    },
    {
        unicode: '1f199',
        name: 'UP!_button',
        decimal: '&#127385;',
        category: 'symbols',
    },
    {
        unicode: '1f19a',
        name: 'VS_button',
        decimal: '&#127386;',
        category: 'symbols',
    },
    {
        unicode: '1f201',
        name: 'Japanese_here_button',
        decimal: '&#127489;',
        category: 'symbols',
    },
    {
        unicode: '1f202',
        name: 'Japanese_service_charge_button',
        decimal: '&#127490;',
        category: 'symbols',
    },
    {
        unicode: '1f237',
        name: 'Japanese_monthly_amount_button',
        decimal: '&#127543;',
        category: 'symbols',
    },
    {
        unicode: '1f236',
        name: 'Japanese_not_free_of_charge_button',
        decimal: '&#127542;',
        category: 'symbols',
    },
    {
        unicode: '1f22f',
        name: 'Japanese_reserved_button',
        decimal: '&#127535;',
        category: 'symbols',
    },
    {
        unicode: '1f250',
        name: 'Japanese_bargain_button',
        decimal: '&#127568;',
        category: 'symbols',
    },
    {
        unicode: '1f239',
        name: 'Japanese_discount_button',
        decimal: '&#127545;',
        category: 'symbols',
    },
    {
        unicode: '1f21a',
        name: 'Japanese_free_of_charge_button',
        decimal: '&#127514;',
        category: 'symbols',
    },
    {
        unicode: '1f232',
        name: 'Japanese_prohibited_button',
        decimal: '&#127538;',
        category: 'symbols',
    },
    {
        unicode: '1f251',
        name: 'Japanese_acceptable_button',
        decimal: '&#127569;',
        category: 'symbols',
    },
    {
        unicode: '1f238',
        name: 'Japanese_application_button',
        decimal: '&#127544;',
        category: 'symbols',
    },
    {
        unicode: '1f234',
        name: 'Japanese_passing_grade_button',
        decimal: '&#127540;',
        category: 'symbols',
    },
    {
        unicode: '1f233',
        name: 'Japanese_vacancy_button',
        decimal: '&#127539;',
        category: 'symbols',
    },
    {
        unicode: '3297',
        name: 'Japanese_congratulations_button',
        decimal: '&#12951;',
        category: 'symbols',
    },
    {
        unicode: '3299',
        name: 'Japanese_secret_button',
        decimal: '&#12953;',
        category: 'symbols',
    },
    {
        unicode: '1f23a',
        name: 'Japanese_open_for_business_button',
        decimal: '&#127546;',
        category: 'symbols',
    },
    {
        unicode: '1f235',
        name: 'Japanese_no_vacancy_button',
        decimal: '&#127541;',
        category: 'symbols',
    },
    {
        unicode: '1f534',
        name: 'red_circle',
        decimal: '&#128308;',
        category: 'symbols',
    },
    {
        unicode: '1f535',
        name: 'blue_circle',
        decimal: '&#128309;',
        category: 'symbols',
    },
    {
        unicode: '26ab',
        name: 'black_circle',
        decimal: '&#9899;',
        category: 'symbols',
    },
    {
        unicode: '26aa',
        name: 'white_circle',
        decimal: '&#9898;',
        category: 'symbols',
    },
    {
        unicode: '2b1b',
        name: 'black_large_square',
        decimal: '&#11035;',
        category: 'symbols',
    },
    {
        unicode: '2b1c',
        name: 'white_large_square',
        decimal: '&#11036;',
        category: 'symbols',
    },
    {
        unicode: '25fc',
        name: 'black_medium_square',
        decimal: '&#9724;',
        category: 'symbols',
    },
    {
        unicode: '25fb',
        name: 'white_medium_square',
        decimal: '&#9723;',
        category: 'symbols',
    },
    {
        unicode: '25fe',
        name: 'black_medium-small_square',
        decimal: '&#9726;',
        category: 'symbols',
    },
    {
        unicode: '25fd',
        name: 'white_medium-small_square',
        decimal: '&#9725;',
        category: 'symbols',
    },
    {
        unicode: '25aa',
        name: 'black_small_square',
        decimal: '&#9642;',
        category: 'symbols',
    },
    {
        unicode: '25ab',
        name: 'white_small_square',
        decimal: '&#9643;',
        category: 'symbols',
    },
    {
        unicode: '1f536',
        name: 'large_orange_diamond',
        decimal: '&#128310;',
        category: 'symbols',
    },
    {
        unicode: '1f537',
        name: 'large_blue_diamond',
        decimal: '&#128311;',
        category: 'symbols',
    },
    {
        unicode: '1f538',
        name: 'small_orange_diamond',
        decimal: '&#128312;',
        category: 'symbols',
    },
    {
        unicode: '1f539',
        name: 'small_blue_diamond',
        decimal: '&#128313;',
        category: 'symbols',
    },
    {
        unicode: '1f53a',
        name: 'red_triangle_pointed_up',
        decimal: '&#128314;',
        category: 'symbols',
    },
    {
        unicode: '1f53b',
        name: 'red_triangle_pointed_down',
        decimal: '&#128315;',
        category: 'symbols',
    },
    {
        unicode: '1f4a0',
        name: 'diamond_with_a_dot',
        decimal: '&#128160;',
        category: 'symbols',
    },
    {
        unicode: '1f518',
        name: 'radio_button',
        decimal: '&#128280;',
        category: 'symbols',
    },
    {
        unicode: '1f533',
        name: 'white_square_button',
        decimal: '&#128307;',
        category: 'symbols',
    },
    {
        unicode: '1f532',
        name: 'black_square_button',
        decimal: '&#128306;',
        category: 'symbols',
    },
    {
        unicode: '1f3c1',
        name: 'checkered_flag',
        decimal: '&#127937;',
        category: 'flags',
    },
    {
        unicode: '1f6a9',
        name: 'triangular_flag_on_post',
        decimal: '&#128681;',
        category: 'flags',
    },
    {
        unicode: '1f38c',
        name: 'crossed_flags',
        decimal: '&#127884;',
        category: 'flags',
    },
    {
        unicode: '1f3f4',
        name: 'waving_black_flag',
        decimal: '&#127988;',
        category: 'flags',
    },
    {
        unicode: '1f3f3',
        name: 'waving_white_flag',
        decimal: '&#127987;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1e8',
        name: 'flag-ac',
        decimal: '&#127462;&#127464;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1e9',
        name: 'flag-ad',
        decimal: '&#127462;&#127465;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1ea',
        name: 'flag-ae',
        decimal: '&#127462;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1eb',
        name: 'flag-af',
        decimal: '&#127462;&#127467;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1ec',
        name: 'flag-ag',
        decimal: '&#127462;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1ee',
        name: 'flag-ai',
        decimal: '&#127462;&#127470;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1f1',
        name: 'flag-al',
        decimal: '&#127462;&#127473;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1f2',
        name: 'flag-am',
        decimal: '&#127462;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1f4',
        name: 'flag-ao',
        decimal: '&#127462;&#127476;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1f6',
        name: 'flag-aq',
        decimal: '&#127462;&#127478;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1f7',
        name: 'flag-ar',
        decimal: '&#127462;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1f8',
        name: 'flag-as',
        decimal: '&#127462;&#127480;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1f9',
        name: 'flag-at',
        decimal: '&#127462;&#127481;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1fa',
        name: 'flag-au',
        decimal: '&#127462;&#127482;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1fc',
        name: 'flag-aw',
        decimal: '&#127462;&#127484;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1fd',
        name: 'flag-ax',
        decimal: '&#127462;&#127485;',
        category: 'flags',
    },
    {
        unicode: '1f1e6-1f1ff',
        name: 'flag-az',
        decimal: '&#127462;&#127487;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1e6',
        name: 'flag-ba',
        decimal: '&#127463;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1e7',
        name: 'flag-bb',
        decimal: '&#127463;&#127463;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1e9',
        name: 'flag-bd',
        decimal: '&#127463;&#127465;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1ea',
        name: 'flag-be',
        decimal: '&#127463;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1eb',
        name: 'flag-bf',
        decimal: '&#127463;&#127467;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1ec',
        name: 'flag-bg',
        decimal: '&#127463;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1ed',
        name: 'flag-bh',
        decimal: '&#127463;&#127469;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1ee',
        name: 'flag-bi',
        decimal: '&#127463;&#127470;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1ef',
        name: 'flag-bj',
        decimal: '&#127463;&#127471;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1f1',
        name: 'flag-bl',
        decimal: '&#127463;&#127473;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1f2',
        name: 'flag-bm',
        decimal: '&#127463;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1f3',
        name: 'flag-bn',
        decimal: '&#127463;&#127475;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1f4',
        name: 'flag-bo',
        decimal: '&#127463;&#127476;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1f6',
        name: 'flag-bq',
        decimal: '&#127463;&#127478;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1f7',
        name: 'flag-br',
        decimal: '&#127463;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1f8',
        name: 'flag-bs',
        decimal: '&#127463;&#127480;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1f9',
        name: 'flag-bt',
        decimal: '&#127463;&#127481;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1fb',
        name: 'flag-bv',
        decimal: '&#127463;&#127483;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1fc',
        name: 'flag-bw',
        decimal: '&#127463;&#127484;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1fe',
        name: 'flag-by',
        decimal: '&#127463;&#127486;',
        category: 'flags',
    },
    {
        unicode: '1f1e7-1f1ff',
        name: 'flag-bz',
        decimal: '&#127463;&#127487;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1e6',
        name: 'flag-ca',
        decimal: '&#127464;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1e8',
        name: 'flag-cc',
        decimal: '&#127464;&#127464;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1e9',
        name: 'flag-cd',
        decimal: '&#127464;&#127465;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1eb',
        name: 'flag-cf',
        decimal: '&#127464;&#127467;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1ec',
        name: 'flag-cg',
        decimal: '&#127464;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1ed',
        name: 'flag-ch',
        decimal: '&#127464;&#127469;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1ee',
        name: 'flag-ci',
        decimal: '&#127464;&#127470;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1f0',
        name: 'flag-ck',
        decimal: '&#127464;&#127472;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1f1',
        name: 'flag-cl',
        decimal: '&#127464;&#127473;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1f2',
        name: 'flag-cm',
        decimal: '&#127464;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1f3',
        name: 'flag-cn',
        decimal: '&#127464;&#127475;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1f4',
        name: 'flag-co',
        decimal: '&#127464;&#127476;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1f5',
        name: 'flag-cp',
        decimal: '&#127464;&#127477;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1f7',
        name: 'flag-cr',
        decimal: '&#127464;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1fa',
        name: 'flag-cu',
        decimal: '&#127464;&#127482;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1fb',
        name: 'flag-cv',
        decimal: '&#127464;&#127483;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1fc',
        name: 'flag-cw',
        decimal: '&#127464;&#127484;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1fd',
        name: 'flag-cx',
        decimal: '&#127464;&#127485;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1fe',
        name: 'flag-cy',
        decimal: '&#127464;&#127486;',
        category: 'flags',
    },
    {
        unicode: '1f1e8-1f1ff',
        name: 'flag-cz',
        decimal: '&#127464;&#127487;',
        category: 'flags',
    },
    {
        unicode: '1f1e9-1f1ea',
        name: 'flag-de',
        decimal: '&#127465;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1e9-1f1ec',
        name: 'flag-dg',
        decimal: '&#127465;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1e9-1f1ef',
        name: 'flag-dj',
        decimal: '&#127465;&#127471;',
        category: 'flags',
    },
    {
        unicode: '1f1e9-1f1f0',
        name: 'flag-dk',
        decimal: '&#127465;&#127472;',
        category: 'flags',
    },
    {
        unicode: '1f1e9-1f1f2',
        name: 'flag-dm',
        decimal: '&#127465;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1e9-1f1f4',
        name: 'flag-do',
        decimal: '&#127465;&#127476;',
        category: 'flags',
    },
    {
        unicode: '1f1e9-1f1ff',
        name: 'flag-dz',
        decimal: '&#127465;&#127487;',
        category: 'flags',
    },
    {
        unicode: '1f1ea-1f1e6',
        name: 'flag-ea',
        decimal: '&#127466;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1ea-1f1e8',
        name: 'flag-ec',
        decimal: '&#127466;&#127464;',
        category: 'flags',
    },
    {
        unicode: '1f1ea-1f1ea',
        name: 'flag-ee',
        decimal: '&#127466;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1ea-1f1ec',
        name: 'flag-eg',
        decimal: '&#127466;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1ea-1f1ed',
        name: 'flag-eh',
        decimal: '&#127466;&#127469;',
        category: 'flags',
    },
    {
        unicode: '1f1ea-1f1f7',
        name: 'flag-er',
        decimal: '&#127466;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1ea-1f1f8',
        name: 'flag-es',
        decimal: '&#127466;&#127480;',
        category: 'flags',
    },
    {
        unicode: '1f1ea-1f1f9',
        name: 'flag-et',
        decimal: '&#127466;&#127481;',
        category: 'flags',
    },
    {
        unicode: '1f1ea-1f1fa',
        name: 'flag-eu',
        decimal: '&#127466;&#127482;',
        category: 'flags',
    },
    {
        unicode: '1f1eb-1f1ee',
        name: 'flag-fi',
        decimal: '&#127467;&#127470;',
        category: 'flags',
    },
    {
        unicode: '1f1eb-1f1ef',
        name: 'flag-fj',
        decimal: '&#127467;&#127471;',
        category: 'flags',
    },
    {
        unicode: '1f1eb-1f1f0',
        name: 'flag-fk',
        decimal: '&#127467;&#127472;',
        category: 'flags',
    },
    {
        unicode: '1f1eb-1f1f2',
        name: 'flag-fm',
        decimal: '&#127467;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1eb-1f1f4',
        name: 'flag-fo',
        decimal: '&#127467;&#127476;',
        category: 'flags',
    },
    {
        unicode: '1f1eb-1f1f7',
        name: 'flag-fr',
        decimal: '&#127467;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1e6',
        name: 'flag-ga',
        decimal: '&#127468;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1e7',
        name: 'flag-gb',
        decimal: '&#127468;&#127463;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1e9',
        name: 'flag-gd',
        decimal: '&#127468;&#127465;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1ea',
        name: 'flag-ge',
        decimal: '&#127468;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1eb',
        name: 'flag-gf',
        decimal: '&#127468;&#127467;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1ec',
        name: 'flag-gg',
        decimal: '&#127468;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1ed',
        name: 'flag-gh',
        decimal: '&#127468;&#127469;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1ee',
        name: 'flag-gi',
        decimal: '&#127468;&#127470;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1f1',
        name: 'flag-gl',
        decimal: '&#127468;&#127473;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1f2',
        name: 'flag-gm',
        decimal: '&#127468;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1f3',
        name: 'flag-gn',
        decimal: '&#127468;&#127475;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1f5',
        name: 'flag-gp',
        decimal: '&#127468;&#127477;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1f6',
        name: 'flag-gq',
        decimal: '&#127468;&#127478;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1f7',
        name: 'flag-gr',
        decimal: '&#127468;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1f8',
        name: 'flag-gs',
        decimal: '&#127468;&#127480;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1f9',
        name: 'flag-gt',
        decimal: '&#127468;&#127481;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1fa',
        name: 'flag-gu',
        decimal: '&#127468;&#127482;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1fc',
        name: 'flag-gw',
        decimal: '&#127468;&#127484;',
        category: 'flags',
    },
    {
        unicode: '1f1ec-1f1fe',
        name: 'flag-gy',
        decimal: '&#127468;&#127486;',
        category: 'flags',
    },
    {
        unicode: '1f1ed-1f1f0',
        name: 'flag-hk',
        decimal: '&#127469;&#127472;',
        category: 'flags',
    },
    {
        unicode: '1f1ed-1f1f2',
        name: 'flag-hm',
        decimal: '&#127469;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1ed-1f1f3',
        name: 'flag-hn',
        decimal: '&#127469;&#127475;',
        category: 'flags',
    },
    {
        unicode: '1f1ed-1f1f7',
        name: 'flag-hr',
        decimal: '&#127469;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1ed-1f1f9',
        name: 'flag-ht',
        decimal: '&#127469;&#127481;',
        category: 'flags',
    },
    {
        unicode: '1f1ed-1f1fa',
        name: 'flag-hu',
        decimal: '&#127469;&#127482;',
        category: 'flags',
    },
    {
        unicode: '1f1ee-1f1e8',
        name: 'flag-ic',
        decimal: '&#127470;&#127464;',
        category: 'flags',
    },
    {
        unicode: '1f1ee-1f1e9',
        name: 'flag-id',
        decimal: '&#127470;&#127465;',
        category: 'flags',
    },
    {
        unicode: '1f1ee-1f1ea',
        name: 'flag-ie',
        decimal: '&#127470;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1ee-1f1f1',
        name: 'flag-il',
        decimal: '&#127470;&#127473;',
        category: 'flags',
    },
    {
        unicode: '1f1ee-1f1f2',
        name: 'flag-im',
        decimal: '&#127470;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1ee-1f1f3',
        name: 'flag-in',
        decimal: '&#127470;&#127475;',
        category: 'flags',
    },
    {
        unicode: '1f1ee-1f1f4',
        name: 'flag-io',
        decimal: '&#127470;&#127476;',
        category: 'flags',
    },
    {
        unicode: '1f1ee-1f1f6',
        name: 'flag-iq',
        decimal: '&#127470;&#127478;',
        category: 'flags',
    },
    {
        unicode: '1f1ee-1f1f7',
        name: 'flag-ir',
        decimal: '&#127470;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1ee-1f1f8',
        name: 'flag-is',
        decimal: '&#127470;&#127480;',
        category: 'flags',
    },
    {
        unicode: '1f1ee-1f1f9',
        name: 'flag-it',
        decimal: '&#127470;&#127481;',
        category: 'flags',
    },
    {
        unicode: '1f1ef-1f1ea',
        name: 'flag-je',
        decimal: '&#127471;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1ef-1f1f2',
        name: 'flag-jm',
        decimal: '&#127471;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1ef-1f1f4',
        name: 'flag-jo',
        decimal: '&#127471;&#127476;',
        category: 'flags',
    },
    {
        unicode: '1f1ef-1f1f5',
        name: 'flag-jp',
        decimal: '&#127471;&#127477;',
        category: 'flags',
    },
    {
        unicode: '1f1f0-1f1ea',
        name: 'flag-ke',
        decimal: '&#127472;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1f0-1f1ec',
        name: 'flag-kg',
        decimal: '&#127472;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1f0-1f1ed',
        name: 'flag-kh',
        decimal: '&#127472;&#127469;',
        category: 'flags',
    },
    {
        unicode: '1f1f0-1f1ee',
        name: 'flag-ki',
        decimal: '&#127472;&#127470;',
        category: 'flags',
    },
    {
        unicode: '1f1f0-1f1f2',
        name: 'flag-km',
        decimal: '&#127472;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1f0-1f1f3',
        name: 'flag-kn',
        decimal: '&#127472;&#127475;',
        category: 'flags',
    },
    {
        unicode: '1f1f0-1f1f5',
        name: 'flag-kp',
        decimal: '&#127472;&#127477;',
        category: 'flags',
    },
    {
        unicode: '1f1f0-1f1f7',
        name: 'flag-kr',
        decimal: '&#127472;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1f0-1f1fc',
        name: 'flag-kw',
        decimal: '&#127472;&#127484;',
        category: 'flags',
    },
    {
        unicode: '1f1f0-1f1fe',
        name: 'flag-ky',
        decimal: '&#127472;&#127486;',
        category: 'flags',
    },
    {
        unicode: '1f1f0-1f1ff',
        name: 'flag-kz',
        decimal: '&#127472;&#127487;',
        category: 'flags',
    },
    {
        unicode: '1f1f1-1f1e6',
        name: 'flag-la',
        decimal: '&#127473;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1f1-1f1e7',
        name: 'flag-lb',
        decimal: '&#127473;&#127463;',
        category: 'flags',
    },
    {
        unicode: '1f1f1-1f1e8',
        name: 'flag-lc',
        decimal: '&#127473;&#127464;',
        category: 'flags',
    },
    {
        unicode: '1f1f1-1f1ee',
        name: 'flag-li',
        decimal: '&#127473;&#127470;',
        category: 'flags',
    },
    {
        unicode: '1f1f1-1f1f0',
        name: 'flag-lk',
        decimal: '&#127473;&#127472;',
        category: 'flags',
    },
    {
        unicode: '1f1f1-1f1f7',
        name: 'flag-lr',
        decimal: '&#127473;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1f1-1f1f8',
        name: 'flag-ls',
        decimal: '&#127473;&#127480;',
        category: 'flags',
    },
    {
        unicode: '1f1f1-1f1f9',
        name: 'flag-lt',
        decimal: '&#127473;&#127481;',
        category: 'flags',
    },
    {
        unicode: '1f1f1-1f1fa',
        name: 'flag-lu',
        decimal: '&#127473;&#127482;',
        category: 'flags',
    },
    {
        unicode: '1f1f1-1f1fb',
        name: 'flag-lv',
        decimal: '&#127473;&#127483;',
        category: 'flags',
    },
    {
        unicode: '1f1f1-1f1fe',
        name: 'flag-ly',
        decimal: '&#127473;&#127486;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1e6',
        name: 'flag-ma',
        decimal: '&#127474;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1e8',
        name: 'flag-mc',
        decimal: '&#127474;&#127464;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1e9',
        name: 'flag-md',
        decimal: '&#127474;&#127465;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1ea',
        name: 'flag-me',
        decimal: '&#127474;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1eb',
        name: 'flag-mf',
        decimal: '&#127474;&#127467;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1ec',
        name: 'flag-mg',
        decimal: '&#127474;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1ed',
        name: 'flag-mh',
        decimal: '&#127474;&#127469;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1f0',
        name: 'flag-mk',
        decimal: '&#127474;&#127472;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1f1',
        name: 'flag-ml',
        decimal: '&#127474;&#127473;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1f2',
        name: 'flag-mm',
        decimal: '&#127474;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1f3',
        name: 'flag-mn',
        decimal: '&#127474;&#127475;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1f4',
        name: 'flag-mo',
        decimal: '&#127474;&#127476;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1f5',
        name: 'flag-mp',
        decimal: '&#127474;&#127477;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1f6',
        name: 'flag-mq',
        decimal: '&#127474;&#127478;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1f7',
        name: 'flag-mr',
        decimal: '&#127474;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1f8',
        name: 'flag-ms',
        decimal: '&#127474;&#127480;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1f9',
        name: 'flag-mt',
        decimal: '&#127474;&#127481;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1fa',
        name: 'flag-mu',
        decimal: '&#127474;&#127482;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1fb',
        name: 'flag-mv',
        decimal: '&#127474;&#127483;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1fc',
        name: 'flag-mw',
        decimal: '&#127474;&#127484;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1fd',
        name: 'flag-mx',
        decimal: '&#127474;&#127485;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1fe',
        name: 'flag-my',
        decimal: '&#127474;&#127486;',
        category: 'flags',
    },
    {
        unicode: '1f1f2-1f1ff',
        name: 'flag-mz',
        decimal: '&#127474;&#127487;',
        category: 'flags',
    },
    {
        unicode: '1f1f3-1f1e6',
        name: 'flag-na',
        decimal: '&#127475;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1f3-1f1e8',
        name: 'flag-nc',
        decimal: '&#127475;&#127464;',
        category: 'flags',
    },
    {
        unicode: '1f1f3-1f1ea',
        name: 'flag-ne',
        decimal: '&#127475;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1f3-1f1eb',
        name: 'flag-nf',
        decimal: '&#127475;&#127467;',
        category: 'flags',
    },
    {
        unicode: '1f1f3-1f1ec',
        name: 'flag-ng',
        decimal: '&#127475;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1f3-1f1ee',
        name: 'flag-ni',
        decimal: '&#127475;&#127470;',
        category: 'flags',
    },
    {
        unicode: '1f1f3-1f1f1',
        name: 'flag-nl',
        decimal: '&#127475;&#127473;',
        category: 'flags',
    },
    {
        unicode: '1f1f3-1f1f4',
        name: 'flag-no',
        decimal: '&#127475;&#127476;',
        category: 'flags',
    },
    {
        unicode: '1f1f3-1f1f5',
        name: 'flag-np',
        decimal: '&#127475;&#127477;',
        category: 'flags',
    },
    {
        unicode: '1f1f3-1f1f7',
        name: 'flag-nr',
        decimal: '&#127475;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1f3-1f1fa',
        name: 'flag-nu',
        decimal: '&#127475;&#127482;',
        category: 'flags',
    },
    {
        unicode: '1f1f3-1f1ff',
        name: 'flag-nz',
        decimal: '&#127475;&#127487;',
        category: 'flags',
    },
    {
        unicode: '1f1f4-1f1f2',
        name: 'flag-om',
        decimal: '&#127476;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1e6',
        name: 'flag-pa',
        decimal: '&#127477;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1ea',
        name: 'flag-pe',
        decimal: '&#127477;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1eb',
        name: 'flag-pf',
        decimal: '&#127477;&#127467;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1ec',
        name: 'flag-pg',
        decimal: '&#127477;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1ed',
        name: 'flag-ph',
        decimal: '&#127477;&#127469;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1f0',
        name: 'flag-pk',
        decimal: '&#127477;&#127472;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1f1',
        name: 'flag-pl',
        decimal: '&#127477;&#127473;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1f2',
        name: 'flag-pm',
        decimal: '&#127477;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1f3',
        name: 'flag-pn',
        decimal: '&#127477;&#127475;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1f7',
        name: 'flag-pr',
        decimal: '&#127477;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1f8',
        name: 'flag-ps',
        decimal: '&#127477;&#127480;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1f9',
        name: 'flag-pt',
        decimal: '&#127477;&#127481;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1fc',
        name: 'flag-pw',
        decimal: '&#127477;&#127484;',
        category: 'flags',
    },
    {
        unicode: '1f1f5-1f1fe',
        name: 'flag-py',
        decimal: '&#127477;&#127486;',
        category: 'flags',
    },
    {
        unicode: '1f1f6-1f1e6',
        name: 'flag-qa',
        decimal: '&#127478;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1f7-1f1ea',
        name: 'flag-re',
        decimal: '&#127479;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1f7-1f1f4',
        name: 'flag-ro',
        decimal: '&#127479;&#127476;',
        category: 'flags',
    },
    {
        unicode: '1f1f7-1f1f8',
        name: 'flag-rs',
        decimal: '&#127479;&#127480;',
        category: 'flags',
    },
    {
        unicode: '1f1f7-1f1fa',
        name: 'flag-ru',
        decimal: '&#127479;&#127482;',
        category: 'flags',
    },
    {
        unicode: '1f1f7-1f1fc',
        name: 'flag-rw',
        decimal: '&#127479;&#127484;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1e6',
        name: 'flag-sa',
        decimal: '&#127480;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1e7',
        name: 'flag-sb',
        decimal: '&#127480;&#127463;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1e8',
        name: 'flag-sc',
        decimal: '&#127480;&#127464;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1e9',
        name: 'flag-sd',
        decimal: '&#127480;&#127465;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1ea',
        name: 'flag-se',
        decimal: '&#127480;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1ec',
        name: 'flag-sg',
        decimal: '&#127480;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1ed',
        name: 'flag-sh',
        decimal: '&#127480;&#127469;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1ee',
        name: 'flag-si',
        decimal: '&#127480;&#127470;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1ef',
        name: 'flag-sj',
        decimal: '&#127480;&#127471;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1f0',
        name: 'flag-sk',
        decimal: '&#127480;&#127472;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1f1',
        name: 'flag-sl',
        decimal: '&#127480;&#127473;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1f2',
        name: 'flag-sm',
        decimal: '&#127480;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1f3',
        name: 'flag-sn',
        decimal: '&#127480;&#127475;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1f4',
        name: 'flag-so',
        decimal: '&#127480;&#127476;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1f7',
        name: 'flag-sr',
        decimal: '&#127480;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1f8',
        name: 'flag-ss',
        decimal: '&#127480;&#127480;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1f9',
        name: 'flag-st',
        decimal: '&#127480;&#127481;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1fb',
        name: 'flag-sv',
        decimal: '&#127480;&#127483;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1fd',
        name: 'flag-sx',
        decimal: '&#127480;&#127485;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1fe',
        name: 'flag-sy',
        decimal: '&#127480;&#127486;',
        category: 'flags',
    },
    {
        unicode: '1f1f8-1f1ff',
        name: 'flag-sz',
        decimal: '&#127480;&#127487;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1e6',
        name: 'flag-ta',
        decimal: '&#127481;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1e8',
        name: 'flag-tc',
        decimal: '&#127481;&#127464;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1e9',
        name: 'flag-td',
        decimal: '&#127481;&#127465;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1eb',
        name: 'flag-tf',
        decimal: '&#127481;&#127467;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1ec',
        name: 'flag-tg',
        decimal: '&#127481;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1ed',
        name: 'flag-th',
        decimal: '&#127481;&#127469;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1ef',
        name: 'flag-tj',
        decimal: '&#127481;&#127471;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1f0',
        name: 'flag-tk',
        decimal: '&#127481;&#127472;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1f1',
        name: 'flag-tl',
        decimal: '&#127481;&#127473;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1f2',
        name: 'flag-tm',
        decimal: '&#127481;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1f3',
        name: 'flag-tn',
        decimal: '&#127481;&#127475;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1f4',
        name: 'flag-to',
        decimal: '&#127481;&#127476;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1f7',
        name: 'flag-tr',
        decimal: '&#127481;&#127479;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1f9',
        name: 'flag-tt',
        decimal: '&#127481;&#127481;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1fb',
        name: 'flag-tv',
        decimal: '&#127481;&#127483;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1fc',
        name: 'flag-tw',
        decimal: '&#127481;&#127484;',
        category: 'flags',
    },
    {
        unicode: '1f1f9-1f1ff',
        name: 'flag-tz',
        decimal: '&#127481;&#127487;',
        category: 'flags',
    },
    {
        unicode: '1f1fa-1f1e6',
        name: 'flag-ua',
        decimal: '&#127482;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1fa-1f1ec',
        name: 'flag-ug',
        decimal: '&#127482;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1fa-1f1f2',
        name: 'flag-um',
        decimal: '&#127482;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1fa-1f1f8',
        name: 'flag-us',
        decimal: '&#127482;&#127480;',
        category: 'flags',
    },
    {
        unicode: '1f1fa-1f1fe',
        name: 'flag-uy',
        decimal: '&#127482;&#127486;',
        category: 'flags',
    },
    {
        unicode: '1f1fa-1f1ff',
        name: 'flag-uz',
        decimal: '&#127482;&#127487;',
        category: 'flags',
    },
    {
        unicode: '1f1fb-1f1e6',
        name: 'flag-va',
        decimal: '&#127483;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1fb-1f1e8',
        name: 'flag-vc',
        decimal: '&#127483;&#127464;',
        category: 'flags',
    },
    {
        unicode: '1f1fb-1f1ea',
        name: 'flag-ve',
        decimal: '&#127483;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1fb-1f1ec',
        name: 'flag-vg',
        decimal: '&#127483;&#127468;',
        category: 'flags',
    },
    {
        unicode: '1f1fb-1f1ee',
        name: 'flag-vi',
        decimal: '&#127483;&#127470;',
        category: 'flags',
    },
    {
        unicode: '1f1fb-1f1f3',
        name: 'flag-vn',
        decimal: '&#127483;&#127475;',
        category: 'flags',
    },
    {
        unicode: '1f1fb-1f1fa',
        name: 'flag-vu',
        decimal: '&#127483;&#127482;',
        category: 'flags',
    },
    {
        unicode: '1f1fc-1f1eb',
        name: 'flag-wf',
        decimal: '&#127484;&#127467;',
        category: 'flags',
    },
    {
        unicode: '1f1fc-1f1f8',
        name: 'flag-ws',
        decimal: '&#127484;&#127480;',
        category: 'flags',
    },
    {
        unicode: '1f1fd-1f1f0',
        name: 'flag-xk',
        decimal: '&#127485;&#127472;',
        category: 'flags',
    },
    {
        unicode: '1f1fe-1f1ea',
        name: 'flag-ye',
        decimal: '&#127486;&#127466;',
        category: 'flags',
    },
    {
        unicode: '1f1fe-1f1f9',
        name: 'flag-yt',
        decimal: '&#127486;&#127481;',
        category: 'flags',
    },
    {
        unicode: '1f1ff-1f1e6',
        name: 'flag-za',
        decimal: '&#127487;&#127462;',
        category: 'flags',
    },
    {
        unicode: '1f1ff-1f1f2',
        name: 'flag-zm',
        decimal: '&#127487;&#127474;',
        category: 'flags',
    },
    {
        unicode: '1f1ff-1f1fc',
        name: 'flag-zw',
        decimal: '&#127487;&#127484;',
        category: 'flags',
    },
];

export const getUnicodeString = (unicode: string): any => {
    return String.fromCodePoint(
        ...unicode.split('-').map((value: any): any => {
            return parseInt(value, 16);
        }),
    );
};
